<template>
	<div class="main">
		<!-- 顶部操作栏 -->
		<div class="operation-bar">
			<el-form :inline="true" :model="searchForm" class="search-form">
				<el-form-item label="店铺">
					<el-select v-model="searchForm.shop" placeholder="选择店铺" style="width:200px" filterable
						@change="onShopChange">
						<el-option v-for="item in filters" :key="item.value" :label="item.text" :value="item.value" />
					</el-select>
				</el-form-item>
				<el-form-item label="本地父体">
					<el-select v-model="searchForm.parentName" @change="onParentChange" placeholder="选择父体" style="width:280px" filterable
						clearable>
						<el-option v-for="p in parentOptions" :key="p.value" :label="p.text" :value="p.value" />
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleSearch" :loading="isSending">查询</el-button>
					<el-button @click="resetSearch">重置</el-button>
				</el-form-item>
			</el-form>
			<div class="action-btns-group">
				<el-button @click="change_all" :loading="isSending18" size="small">建议置换</el-button>
				<el-button @click="jojo2" :loading="isSending18" size="small">一键采购</el-button>
                <el-button @click="allupdate" size="small">批量编辑</el-button>
                <el-button @click="dialogTaskPanel = true" size="small">任务面板</el-button>
		</div>
		</div>

		<!-- 数据表格区域 -->
		<div class="table-area">
			<div class="table-header-bar">
				<span class="table-title">品名数据列表</span>
				<el-input v-model="pmFilter" placeholder="筛选本地品名" size="small" style="width:200px"
					clearable prefix-icon="el-icon-search" />
				<el-input v-model="skuFilter" placeholder="筛选SKU" size="small" style="width:160px;margin-left:8px"
					clearable prefix-icon="el-icon-search" />
			</div>
			<el-table :data="filteredTableData" style="width:100%;margin-top:12px" border stripe
				v-loading="isSending" @cell-dblclick="doubleClickCell" :row-style="getRowStyle"
				height="780">
				<el-table-column type="expand">
					<template slot-scope="scope">
						<el-form label-position="left" inline class="demo-table-expand">
							<el-form-item label="会员日备货"><span>{{ scope.row.会员日备货 }}</span></el-form-item>
							<el-form-item label="黑五备货"><span>{{ scope.row.黑五备货 }}</span></el-form-item>
							<el-form-item label="旺季备货"><span>{{ scope.row.旺季备货 }}</span></el-form-item>
						</el-form>
					</template>
				</el-table-column>
				<el-table-column prop="本地父体" label="本地父体" min-width="140" />
				<el-table-column prop="本地品名" label="本地品名" min-width="150" />
				<el-table-column prop="FBA库存" label="FBA库存" width="90" />
				<el-table-column prop="FBA在途" label="FBA在途" width="90" />
				<el-table-column prop="本地库存" label="本地库存" width="90" sortable />
				<el-table-column prop="预计库存" label="预计库存" width="90">
					<template slot-scope="scope">
						<span>{{ scope.row.预计库存 }}</span>
					</template>
				</el-table-column>
				<el-table-column label="采购在途" width="90">
					<template slot-scope="scope">
						{{ scope.row.预计库存 - scope.row.本地库存 }}
					</template>
				</el-table-column>
				<el-table-column label="销量数据" min-width="120" sortable prop="mergedSales"
					:sort-method="sortBy30Days">
					<template slot-scope="scope">
						<div class="sales-wrapper">
							<div class="sales-item">30天销量: {{ scope.row.三十天销量 }}</div>
							<div class="sales-item">14天销量: {{ scope.row.十四天销量 }}</div>
							<div class="sales-item">7天销量: {{ scope.row.七天销量 }}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="安全天数" label="安全天数" width="100">
					<template slot-scope="scope">
						<div :style="{ backgroundColor: calculateSafetyStock(scope.row) < 70 ? 'yellow' : '' }">
							{{ calculateSafetyStock(scope.row) }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="sku" label="SKU" width="90" />
				<el-table-column prop="fnsku" label="FNSKU" width="100" />
				<el-table-column prop="MSKU模版" label="MSKU模版" width="100" />
				<el-table-column prop="供应商" label="供应商" width="90" />
				<el-table-column label="采购数量" width="130">
					<template slot-scope="scope">
						<div class="purchase-wrapper">
							<div class="purchase-item">
								<span class="label">待采购:</span>
								<span class="value">{{ scope.row.预采购数量 }}</span>
							</div>
							<div class="purchase-item">
								<span class="label">已采购:</span>
								<span class="value">{{ scope.row.已采购数量 }}</span>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="指定采购数量" label="指定采购数量" width="120" sortable>
					<template slot-scope="scope">
						<div v-if="!scope.row.edit" style="padding-top:5px;">{{ scope.row.指定采购数量 }}</div>
						<el-input v-else v-model="scope.row.指定采购数量" @blur="levelChange(scope.row)" size="small" />
					</template>
				</el-table-column>
				<el-table-column prop="备货建议" label="备货建议" width="100" sortable />
				<el-table-column prop="状态" label="状态" width="90" fixed="right">
					<template slot-scope="scope">
						<el-tag :type="productStatusType(scope.row.状态)" size="small" effect="plain">
							{{ scope.row.状态 }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="184" fixed="right">
					<template slot-scope="scope">
						<div class="action-btns">
							<el-dropdown @command="command => handleSelect_1(scope.row, command)">
								<el-button size="mini" :loading="isSending4" plain>编辑</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="编辑/详情">编辑/详情</el-dropdown-item>
									<el-dropdown-item command="正常">标记正常</el-dropdown-item>
									<el-dropdown-item command="后补">标记后补</el-dropdown-item>
									<el-dropdown-item command="待淘汰-正常移入">标记待淘汰-正常移入</el-dropdown-item>
									<el-dropdown-item command="淘汰移出">标记淘汰移出</el-dropdown-item>
									<!-- 暂时注释品名配置入口。 -->
									<!-- <el-dropdown-item command="品名配置" divided>品名配置</el-dropdown-item> -->
								</el-dropdown-menu>
							</el-dropdown>
							<el-dropdown v-if="scope.row.采购开关 === '不启用一键采购'" @command="command => selectPurchaseMode(scope.row, command)">
								<el-button size="mini" :loading="isSending5" plain>启动采购<i class="el-icon-arrow-down el-icon--right"></i></el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="normal">启动采购</el-dropdown-item>
									<el-dropdown-item command="new_asin">新建ASIN采购</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<el-button size="mini" :loading="isSending5" type="danger"
								v-else-if="scope.row.采购开关 === '启用一键采购'" @click="caigou2(scope.row)">关闭采购</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="table-tip">
				Tip: 备货天数常态90天，90天计算正数则以120天计算；70天安全库存&gt;70时标黄 |
				<span style="color:red">采购: 填写指定采购数量→选择采购方式；普通采购在编辑弹窗选SKU/FNSKU/仓库，新建ASIN在专用弹窗选SKU/仓库并设置单个ASIN数量上限（最小10）→一键采购</span>
			</div>
		</div>

		<!-- 暂时注释新建 ASIN 的可选超佣源 FNSKU 弹窗。 -->
		<!--
		<el-dialog title="新建 ASIN 选项" :visible.sync="sourceFnskuDialogVisible" width="620px"
			:close-on-click-modal="false">
			<el-alert type="info" :closable="false" show-icon
				title="可选择佣金费率大于 0.4 的源 FNSKU。选择后任务完成时会出现“超佣移出”按钮；不选择则只创建并采购，不产生移出动作。" />
			<el-form label-width="135px" size="small" style="margin-top:16px;">
				<el-form-item label="超佣源 FNSKU">
					<el-select v-model="sourceFnskuValue" clearable filterable placeholder="不选择（仅创建）"
						style="width:100%" :loading="sourceFnskuLoading">
						<el-option v-for="item in sourceFnskuOptions" :key="item.fnsku" :value="item.fnsku"
							:label="sourceFnskuLabel(item)" />
					</el-select>
					<div style="font-size:12px;color:#909399;margin-top:5px;">
						仅展示费率大于 0.4 的候选；库存查看与移出确认在任务面板完成。
					</div>
				</el-form-item>
				<el-form-item label="新建 MSKU 后缀">
					<el-radio-group v-model="sourceMskuSuffix" size="small">
						<el-radio-button label="T">T（发货）</el-radio-button>
						<el-radio-button label="C">C（跟卖）</el-radio-button>
						<el-radio-button label="CUSTOM">自定义</el-radio-button>
					</el-radio-group>
					<el-input v-if="sourceMskuSuffix === 'CUSTOM'" v-model="sourceMskuCustomSuffix"
						placeholder="如 HB，1-6 位字母或数字" maxlength="6" style="width:180px;margin-left:8px;" />
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button @click="cancelSourceFnsku">取消</el-button>
				<el-button type="primary" @click="confirmSourceFnskuSelection">继续</el-button>
			</span>
		</el-dialog>
		-->
		<!-- 暂时注释任务面板组件。 -->
		<!--
		<task-panel-dialog :visible.sync="dialogTaskPanel" mode="create" :shop="filterText"
			show-move-actions />
		-->

		<!-- 编辑弹窗 -->
		<el-dialog :title="title" :visible="dialogVisible1" width="750px" :before-close="handleClose1">
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left"
				:inline="true">
				<el-tooltip :content="'备货公式: ' + form.建议方案" placement="top">
					<el-switch v-model="form.建议方案" active-color="#13ce66" inactive-color="#ff4949"
						active-value="30天销量/30*（备货天数+旺季备货天数+黑五备货天数+会员日备货天数）-FBA库存-FBA在途-预计库存" active-text="建议方案二"
						inactive-text="建议方案一" inactive-value="30天销量/30*备货天数+旺季备货+黑五备货+会员日备货-FBA库存-FBA在途-预计库存">
					</el-switch>
				</el-tooltip>
			</el-form>
			<div>---</div>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left"
				:inline="true">
				<el-form-item label="会员日备货" prop="会员日备货" label-width="100px">
					<el-input v-model="form.会员日备货" placeholder="请输入会员日备货(只能填写数字)" style="width: 50%;" />
				</el-form-item>
				<el-form-item label="*会员日备货天数" prop="会员日备货天数" label-width="120px">
					<el-input v-model="form.会员日备货天数" placeholder="请输入会员日备货天数(只能填写数字)" style="width: 75%" />
				</el-form-item>
			</el-form>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="110px" label-position="left"
				:inline="true">
				<el-form-item label="黑五备货" prop="黑五备货" label-width="100px">
					<el-input v-model="form.黑五备货" placeholder="请输入黑五备货(只能填写数字)" style="width: 50%;" />
				</el-form-item>
				<el-form-item label="*黑五备货天数" prop="黑五备货天数" label-width="110px">
					<el-input v-model="form.黑五备货天数" placeholder="请输入黑五备货天数(只能填写数字)" style="width: 80%;" />
				</el-form-item>
			</el-form>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="110px" label-position="left"
				:inline="true">

				<el-form-item label="旺季备货" prop="旺季备货" label-width="100px">
					<el-input v-model="form.旺季备货" placeholder="请输入旺季备货(只能填写数字)" style="width: 50%;" />
				</el-form-item>
				<el-form-item label="*旺季备货天数" prop="旺季备货天数" label-width="110px">
					<el-input v-model="form.旺季备货天数" placeholder="请输入旺季备货天数(只能填写数字)" style="width: 80%;" />
				</el-form-item>
			</el-form>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left"
				:inline="true">
				<el-tooltip :content="'' + form.采购开关" placement="top">
					<el-switch v-model="form.采购开关" active-color="#13ce66" inactive-color="#ff4949" active-value="启用一键采购"
						inactive-text="采购开关" inactive-value="不启用一键采购">
					</el-switch>
				</el-tooltip>
			</el-form>
			<div>---</div>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="110px" label-position="left"
				:inline="true">
					<el-form-item label="SKU" prop="SKU">
						<el-select v-model="form.sku" clearable placeholder="请选择SKU" style="width: 60%;" filterable
							@change="onEditSkuChange" ref="skuSelect">
						<el-option v-for="item in sku" :key="item.value" :label="item.SKU" :value="item.value"
							autocomplete="off">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left"
				:inline="true">
				<el-tooltip :content="'' + form.是否使用新ASIN" placement="top">
					<el-switch v-model="form.是否使用新ASIN" active-color="#13ce66" inactive-color="#ff4949"
						active-value="工具自动生成新ASIN" inactive-text="是否使用新ASIN" inactive-value="工具使用目前选择FNSKU"
						@change="onEditAsinModeChange">
					</el-switch>
				</el-tooltip>
			</el-form>
			<div>---</div>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="110px" label-position="left"
				:inline="true" v-if="form.是否使用新ASIN === '工具使用目前选择FNSKU'">
				<el-alert title="字段颜色：FNSKU 蓝色、MSKU 黑色；佣率显示红色为 45%，绿色为 15%，原色为无数据"
					type="info" :closable="false" show-icon>
				</el-alert>
				<el-form-item label="FNSKU" prop="FNSKU" style="margin-top: 10px;">
					<el-select v-model="form.fnsku" clearable placeholder="请选择当前SKU已配对的FNSKU" style="width: 100%;"
						filterable :loading="fnskuLoading" no-data-text="当前 SKU 暂无已配对的 FNSKU">
						<el-option v-for="item in fnskuOptions" :key="fnskuOptionKey(item)"
							:label="item.fnsku"
							:value="item.fnsku" :disabled="!!item._ignored" autocomplete="off">
							<span class="fnsku-part-fnsku">{{ item.fnsku }}</span>
							<span class="fnsku-part-sep"> | </span>
							<span class="fnsku-part-msku">{{ item.msku || '-' }}</span>
							<span class="fnsku-part-rate" :style="getRateStyle(fnskuFeeRatio(item))">（佣率 {{ fnskuRateText(item) }}）</span>
							<span v-if="item._ignored" class="fnsku-part-ignored">（已忽略）</span>
							<i v-if="item._ignored" class="el-icon-refresh fnsku-restore-icon" title="恢复该 FNSKU"
								@click.stop="restoreFnsku(item)"></i>
							<i v-else class="el-icon-close fnsku-ignore-icon" title="忽略该 FNSKU"
								@click.stop="ignoreFnsku(item)"></i>
						</el-option>
					</el-select>
					<div v-if="fnskuIgnored.length" class="msku-hint">
						已忽略 {{ fnskuIgnored.length }} 个 FNSKU，排在列表最后，点右侧按钮即可恢复
					</div>
				</el-form-item>
				<el-form-item label="仓库" prop="仓库" style="margin-top: 10px;">
					<el-select v-model="form.仓库" clearable placeholder="由店铺自动确定" style="width: 85%;" filterable
						:disabled="!!lockedWarehouse">
						<el-option v-for="item in cangku" :key="item.value" :label="item.text || item.cangku || item.value" :value="item.value"
							autocomplete="off">
						</el-option>
					</el-select>
					<div class="msku-hint">
						{{ lockedWarehouse ? ('该店铺锁定仓库：' + lockedWarehouse + '（明细只读）')
							: '未配置站点仓库，禁止采购，请先补充店铺站点配置' }}
					</div>
				</el-form-item>
			</el-form>
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="110px" label-position="left"
				:inline="true" v-else-if="form.是否使用新ASIN === '工具自动生成新ASIN'">
				<el-form-item label="MSKU模版" prop="MSKU模版" label-width="100px">
					<el-input v-model="form.MSKU模版" placeholder="请输入MSKU模版" style="width: 80%;" />
				</el-form-item>
				<el-form-item label="供应商" prop="供应商" label-width="100px">
					<el-input v-model="form.供应商" placeholder="请输入供应商" style="width: 80%;" />
				</el-form-item>
				<el-form-item label="仓库" prop="仓库">
					<el-select v-model="form.仓库" clearable placeholder="由店铺自动确定" style="width: 70%;" filterable
						:disabled="!!lockedWarehouse">
						<el-option v-for="item in cangku" :key="item.value" :label="item.text || item.cangku || item.value" :value="item.value"
							autocomplete="off">
						</el-option>
					</el-select>
					<div class="msku-hint">
						{{ lockedWarehouse ? ('该店铺锁定仓库：' + lockedWarehouse + '（明细只读）')
							: '未配置站点仓库，禁止采购，请先补充店铺站点配置' }}
					</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="reset">重置</el-button>
				<el-button type="primary" @click="update_data" :loading="isSending2">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog :title="title" :visible="dialogVisible2" width="40%" :before-close="handleClose2">
			<el-form :model="form1" status-icon :rules="rules" ref="form1" label-width="100px" label-position="left"
				:inline="true">
				<el-tooltip :content="'备货公式: ' + form1.建议方案" placement="top">
					<el-switch v-model="form1.建议方案" active-color="#13ce66" inactive-color="#ff4949"
						active-value="30天销量/30*（备货天数+旺季备货天数+黑五备货天数+会员日备货天数）-FBA库存-FBA在途-预计库存" active-text="建议方案二"
						inactive-text="建议方案一" inactive-value="30天销量/30*备货天数+旺季备货+黑五备货+会员日备货-FBA库存-FBA在途-预计库存">
					</el-switch>
				</el-tooltip>
			</el-form>
			<div>---</div>
			<el-form :model="form1" status-icon :rules="rules" ref="form1" label-width="100px" label-position="left"
				:inline="true">
				<el-form-item label="会员日备货" prop="会员日备货" label-width="100px">
					<el-input v-model="form1.会员日备货" placeholder="请输入会员日备货(只能填写数字)" style="width: 70%;" />
				</el-form-item>
				<el-form-item label="*会员日备货天数" prop="会员日备货天数" label-width="120px">
					<el-input v-model="form1.会员日备货天数" placeholder="请输入会员日备货天数(只能填写数字)" style="width: 75%" />
				</el-form-item>
			</el-form>
			<el-form :model="form1" status-icon :rules="rules" ref="form1" label-width="110px" label-position="left"
				:inline="true">
				<el-form-item label="黑五备货" prop="黑五备货" label-width="100px">
					<el-input v-model="form1.黑五备货" placeholder="请输入黑五备货(只能填写数字)" style="width: 70%;" />
				</el-form-item>
				<el-form-item label="*黑五备货天数" prop="黑五备货天数" label-width="110px">
					<el-input v-model="form1.黑五备货天数" placeholder="请输入黑五备货天数(只能填写数字)" style="width: 80%;" />
				</el-form-item>
			</el-form>
			<el-form :model="form1" status-icon :rules="rules" ref="form1" label-width="110px" label-position="left"
				:inline="true">
				<el-form-item label="旺季备货" prop="旺季备货" label-width="100px">
					<el-input v-model="form1.旺季备货" placeholder="请输入旺季备货(只能填写数字)" style="width: 70%;" />
				</el-form-item>
				<el-form-item label="*旺季备货天数" prop="旺季备货天数" label-width="110px">
					<el-input v-model="form1.旺季备货天数" placeholder="请输入旺季备货天数(只能填写数字)" style="width: 80%;" />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="reset">重置</el-button>
				<el-button type="primary" @click="updateall_data" :loading="isSending2">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog :title="title" :visible="dialogVisible_zd" width="30%" :before-close="handleClose_zd">
			<el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" label-position="left"
				:inline="true">
				<el-form-item label="指定采购数量" prop="指定采购数量" label-width="100px">
					<el-input v-model="form.指定采购数量" placeholder="请输入指定采购数量" style="width: 70%;" />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="reset">重置</el-button>
				<el-button type="primary" @click="zhiding_update" :loading="isSending2">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 暂时注释品名配置弹窗，后续需要恢复时取消此注释。 -->
		<!--
		<pm-config-dialog
			:visible.sync="dialogPmConfigVisible"
			:parent="pmConfigMeta['本地父体']"
			:pm="pmConfigMeta['本地品名']"
			:shop="pmConfigMeta['店铺']"
			:msku="pmConfigMeta.msku"
			:warehouse.sync="pmConfigMeta.warehouse"
			:warehouses="cangku"
			@saved="onPmConfigSaved" />
		-->

		<!-- 单行新建 ASIN 采购需求：在专用弹窗选择关联 SKU/仓库，只保存需求。 -->
		<el-dialog title="新建 ASIN 采购需求" :visible.sync="newAsinRequirementVisible" width="700px"
			custom-class="new-asin-requirement-dialog" :close-on-click-modal="false">
			<div class="new-asin-requirement">
				<el-alert type="info" :closable="false" show-icon
					title="新建 ASIN 只保存采购需求，不依赖已有 FNSKU；刊登、配对及 FNSKU/local_sku 同步完成后才会执行 ERP 采购。" />

				<el-descriptions class="requirement-meta" :column="2" border size="small">
					<el-descriptions-item label="品名">{{ newAsinRequirementForm.pm || '-' }}</el-descriptions-item>
					<el-descriptions-item label="店铺">{{ newAsinRequirementForm.shop || '-' }}</el-descriptions-item>
				</el-descriptions>

				<div class="procurement-config-title">
					<div class="dialog-section-title">采购配置</div>
					<span class="field-help">SKU 和仓库在这里完成，不需要进入普通编辑弹窗</span>
				</div>
				<el-form :model="newAsinRequirementForm" label-position="top" size="small"
					class="procurement-config-form">
					<el-row :gutter="16">
						<el-col :span="12">
							<el-form-item label="关联 SKU" required>
								<el-select v-model="newAsinRequirementForm.sku" clearable filterable
									:loading="newAsinRequirementSkuLoading" placeholder="请选择该品名对应的 SKU"
									style="width:100%">
									<el-option v-for="item in newAsinRequirementSkuOptions"
										:key="item.value || item.SKU" :label="item.SKU || item.value"
										:value="item.value || item.SKU" />
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="新建 ASIN 仓库" required>
								<el-select v-model="newAsinRequirementForm.warehouse" filterable
									:disabled="!!newAsinRequirementLockedWarehouse"
									placeholder="由店铺自动确定" style="width:100%">
									<el-option v-for="item in cangku" :key="item.value"
										:label="item.text || item.cangku || item.value" :value="item.value" />
								</el-select>
								<div class="msku-hint">
									{{ newAsinRequirementLockedWarehouse
										? ('该店铺锁定仓库：' + newAsinRequirementLockedWarehouse + '（明细只读）')
										: '未配置站点仓库，禁止采购，请先补充店铺站点配置' }}
								</div>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="16">
						<el-col :span="12">
							<el-form-item label="采购总量" required>
								<el-input-number v-model="newAsinRequirementForm.total_quantity" :min="1" :step="1"
									:precision="0" controls-position="right" style="width:100%" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="单个 ASIN 数量上限" required>
								<el-input-number v-model="newAsinRequirementForm.quantity_limit" :min="minAsinQuantityLimit" :step="1"
									:precision="0" controls-position="right" style="width:100%" />
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
				<div class="requirement-note field-help">
					采购总量默认取指定采购数量，否则取备货建议；单个 ASIN 数量上限最小 10，默认 10，保存后即为该品名的上限。
				</div>

				<div class="allocation-preview">
					<div class="allocation-preview-header">
						<div class="dialog-section-title">数量分配预览</div>
						<div class="procurement-summary">
							<span class="summary-chip">生成 {{ newAsinRequirementCount }} 个 MSKU</span>
							<span class="summary-chip">分配 {{ newAsinRequirementAssigned }} / {{ newAsinRequirementForm.total_quantity || 0 }}</span>
						</div>
					</div>
					<el-table :data="newAsinRequirementAllocations" size="mini" border>
						<el-table-column type="index" label="#" width="55" />
						<el-table-column prop="quantity" label="采购分配量" />
						<el-table-column label="校验">
							<template slot-scope="scope">{{ scope.row.quantity }} ≤ {{ newAsinRequirementForm.quantity_limit || 0 }}</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<span slot="footer">
				<el-button :disabled="newAsinRequirementSaving" @click="newAsinRequirementVisible = false">取消</el-button>
				<el-button type="primary" :loading="newAsinRequirementSaving"
					:disabled="newAsinRequirementSkuLoading" @click="saveNewAsinRequirement">保存采购需求</el-button>
			</span>
		</el-dialog>

		<!-- 采购需求模板上传先预览，确认后才更新 parent_calculate。 -->
		<el-dialog title="采购需求模板校验与变更预览" :visible.sync="purchaseTemplatePreviewVisible" width="900px"
			:close-on-click-modal="false">
			<el-alert v-if="purchaseTemplatePreview" :type="purchaseTemplatePreview.summary && purchaseTemplatePreview.summary.invalid ? 'warning' : 'success'"
				:closable="false" show-icon
				:title="purchaseTemplatePreview.summary ? ('共 ' + purchaseTemplatePreview.summary.total + ' 行，校验通过 ' + purchaseTemplatePreview.summary.valid + ' 行，失败 ' + purchaseTemplatePreview.summary.invalid + ' 行') : '请检查上传内容'" />
			<el-table v-if="purchaseTemplatePreview" :data="purchaseTemplatePreview.rows" size="mini" border max-height="420" style="margin-top:12px">
				<el-table-column prop="row_no" label="行" width="55" />
				<el-table-column prop="parent" label="本地父体" min-width="130" />
				<el-table-column prop="pm" label="品名" min-width="150" />
				<el-table-column prop="shop" label="店铺" width="110" />
				<el-table-column prop="purchase_mode_label" label="采购模式" width="125" />
				<el-table-column prop="total_quantity" label="总量" width="70" />
				<el-table-column prop="quantity_limit" label="ASIN上限" width="85" />
				<el-table-column label="变更" width="70">
					<template slot-scope="scope">
						<el-tooltip v-if="scope.row.changes && scope.row.changes.length"
							:content="scope.row.changes.map(item => item.field + ': ' + (item.from || '-') + ' → ' + (item.to || '-')).join('；')" placement="top">
							<el-tag type="warning" size="mini">{{ scope.row.changes.length }}项</el-tag>
						</el-tooltip>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="校验">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.valid" type="success" size="mini">通过</el-tag>
						<el-tooltip v-else :content="(scope.row.errors || []).join('；')" placement="top">
							<el-tag type="danger" size="mini">失败</el-tag>
						</el-tooltip>
					</template>
				</el-table-column>
			</el-table>
			<span slot="footer">
				<el-button @click="purchaseTemplatePreviewVisible = false">取消</el-button>
				<el-button type="primary" :loading="purchaseTemplateApplying"
					:disabled="!purchaseTemplatePreview || purchaseTemplatePreview.summary.invalid > 0"
					@click="applyProcurementRequirementImport">确认保存需求</el-button>
			</span>
		</el-dialog>

		<!-- 一键采购统一结果：普通采购结果与新建 ASIN 草稿分开显示。 -->
		<el-dialog title="一键采购结果" :visible.sync="procurementResultVisible" width="900px"
			:close-on-click-modal="false">
			<el-alert v-if="procurementResult" :type="procurementResultAlertType" :closable="false" show-icon
				:title="procurementResultAlertTitle" :description="procurementResult.message || ''" />
			<div v-if="procurementResult && procurementResult.normal" style="margin-top:16px">
				<div class="dialog-section-title">普通采购</div>
				<el-descriptions :column="3" border size="small">
					<el-descriptions-item label="状态">{{ procurementResult.normal.status }}</el-descriptions-item>
					<el-descriptions-item label="结果">{{ procurementResult.normal.message }}</el-descriptions-item>
					<el-descriptions-item label="请求标识">{{ procurementResult.request_id }}</el-descriptions-item>
				</el-descriptions>
				<el-table :data="procurementResult.normal.items || []" size="mini" border style="margin-top:8px">
					<el-table-column prop="key" label="业务行" min-width="280" />
					<el-table-column prop="quantity" label="数量" width="80" />
					<el-table-column prop="status" label="状态" width="100" />
					<el-table-column prop="message" label="说明" min-width="260" />
				</el-table>
			</div>
			<div v-if="procurementResult && (procurementResult.occupied_items || []).length" style="margin-top:16px">
				<el-alert type="warning" :closable="false" show-icon
					title="以下品名已被未确认草稿或其他采购请求占用，本次未处理" />
				<el-table :data="procurementResult.occupied_items" size="mini" border style="margin-top:8px">
					<el-table-column prop="parent" label="本地父体" min-width="180" show-overflow-tooltip />
					<el-table-column prop="pm" label="本地品名" min-width="220" show-overflow-tooltip />
					<el-table-column prop="shop" label="店铺" width="110" />
					<el-table-column prop="occupied_by" label="占用草稿 / 请求" min-width="230" show-overflow-tooltip />
					<el-table-column prop="occupied_by_owner" label="创建人" width="110" />
				</el-table>
				<div class="field-help" style="margin-top:6px">
					占用的草稿只能由其创建人在采购任务面板继续或取消；取消后该品名会重新回到可用状态，可再次一键采购。
				</div>
			</div>
			<div v-if="procurementResult && procurementResult.new_asin_draft" class="draft-entry-card">
				<div>
					<div class="dialog-section-title">新建 ASIN 预览草稿</div>
					<div>草稿标识：{{ procurementResult.new_asin_draft.draft_id }}，版本 {{ procurementResult.new_asin_draft.version }}</div>
					<div class="field-help">当前只保存草稿，尚未调用刊登接口；修改配置后必须二次确认。</div>
				</div>
				<el-button type="primary" size="small" @click="openNewAsinDraft(procurementResult.new_asin_draft)">查看并配置</el-button>
			</div>
			<el-alert v-if="procurementResult && procurementResult.new_asin_error" type="warning" :closable="false"
				show-icon :title="'新建 ASIN 预览失败：' + procurementResult.new_asin_error" style="margin-top:12px" />
			<el-alert v-if="procurementResult && (procurementResult.validation_errors || []).length" type="warning" :closable="false"
				show-icon title="部分采购需求未通过校验">
				<div v-for="error in procurementResult.validation_errors" :key="error">{{ error }}</div>
			</el-alert>
			<span slot="footer">
				<el-button @click="procurementResultVisible = false">关闭</el-button>
				<el-button v-if="procurementResult && procurementResult.new_asin_draft" type="primary"
					@click="openNewAsinDraft(procurementResult.new_asin_draft)">打开新建 ASIN 预览</el-button>
			</span>
		</el-dialog>

        <procurement-task-panel :visible.sync="dialogTaskPanel" :shop="filterText" :parent="searchForm.parentName"
            @resume="openNewAsinDraft($event, true)" />
        <!-- 新建 ASIN 逐 MSKU 草稿：编辑只写草稿，确认按钮才创建统一正式任务。 -->
        <el-dialog :visible.sync="newAsinDraftVisible" width="96%" top="3vh" custom-class="procurement-draft-dialog"
            :close-on-click-modal="false" :show-close="newAsinDraft && newAsinDraft.status === 'draft'">
            <div slot="title" class="draft-dialog-title">
                <span>新建 ASIN 采购草稿</span>
                <el-radio-group v-model="draftView" size="mini" :disabled="newAsinDraftSaving || newAsinDraftImporting || newAsinDraftConfirming">
                    <el-radio-button label="config">配置字段</el-radio-button>
                    <el-radio-button label="preview" :disabled="!draftHasGenerated">生成 MSKU</el-radio-button>
                    <el-radio-button label="result" :disabled="!newAsinDraft || newAsinDraft.status !== 'confirmed'">创建结果</el-radio-button>
                </el-radio-group>
            </div>
            <input ref="procurementDraftFile" type="file" accept=".xlsx" style="display:none" @change="onProcurementDraftFilePicked" />
            <template v-if="newAsinDraft">
                <el-alert v-if="draftView === 'preview' && (newAsinDraft.validation_errors || []).length" class="draft-validation" type="error" :closable="false" show-icon>
                    <div v-for="(error, index) in newAsinDraft.validation_errors" :key="index">{{ error }}</div>
                </el-alert>
                <div v-if="draftView === 'config'" class="draft-config-step">
                    <el-alert type="info" :closable="false" show-icon title="这里复用 Auto 的 MSKU 生成配置表。父体、店铺、采购 SKU、仓库、后缀 T 和创建后配对均来自采购需求并固定；只调整当前草稿的模式、颜色、基础名、供应商、国家和产品类型。" />
                    <div class="draft-toolbar">
                        <span>已选 {{ newAsinDraftItems.length }} 个品名 · 后缀 T（创建发货产品） · 创建后配对 · 生成数量按采购分配固定</span>
                        <el-select v-model="draftBatchProductType" filterable clearable size="small" placeholder="批量选择产品类型" :disabled="!draftCanEdit" @change="applyDraftProductType">
                            <el-option v-for="type in procurementProductTypes" :key="type.value" :label="type.label" :value="type.value" />
                        </el-select>
                    </div>
                    <msku-generation-table ref="procurementDraftGenerationTable" :rows="newAsinDraftItems" :asin="true"
                        :procurement="true" :busy="!draftCanEdit" :actions="draftGenerationTableActions"
                        :product-types="procurementProductTypes" :batch-product-type="draftBatchProductType"
                        @batch-product-type="applyDraftProductType" />
                    <el-alert v-for="group in newAsinDraftItems.filter(item => draftGroupIssue(item))" :key="draftGroupKey(group)" type="warning" :closable="false" class="draft-config-errors">
                        <div>{{ group.pm }}：{{ draftGroupIssue(group) }}</div>
                    </el-alert>
                </div>
                <div v-if="draftView === 'result'" class="draft-result-step">
                    <el-result icon="success" title="新建 ASIN 采购已存库" sub-title="已进入统一任务队列，等待脚本刊登、同步和配对；整批准备结束后采购就绪项。">
                        <template slot="extra"><el-button type="primary" @click="newAsinDraftVisible = false; dialogTaskPanel = true">查看任务面板</el-button></template>
                    </el-result>
                </div>
                <div v-show="draftView === 'preview'" class="gen-multi-results">
                    <el-alert type="info" :closable="false" show-icon class="gen-multi-result-summary"
                        title="MSKU 已生成。下方按品名归组：每个 MSKU 对应一条独立的产品创建记录，主标题按 MSKU 生成独立编号，副标题和其他创建字段默认复用品名配置。展开 MSKU 行可查看该产品类型全部字段；需要修改请先导出字段 Excel（只含 MSKU、MSKU 配置与刊登字段），改好后上传覆盖。" />
                    <div class="batch-asin-generated-toolbar">
                        <span>生成的 MSKU 已归入对应品名，可单独显示或隐藏</span>
                        <div class="batch-asin-generated-toolbar-actions">
                            <el-button type="text" size="mini" @click="expandDraftMskuItems">全部显示</el-button>
                            <el-button type="text" size="mini" @click="collapseDraftMskuItems">全部隐藏</el-button>
                        </div>
                    </div>
                    <div class="draft-groups">
                    <div v-for="group in newAsinDraftItems" :key="draftGroupKey(group)" class="draft-group">
                        <div class="draft-group-header">
                            <strong>{{ group.pm }}</strong>
                            <span class="draft-group-parent">{{ group.parent }} / {{ group.shop }}</span>
                            <el-tag v-if="group.sku" size="mini" type="warning" effect="plain">SKU: {{ group.sku }}</el-tag>
                            <el-tag size="mini" type="info" effect="plain">{{ group.mode === 'template' ? '按模板' : '按属性' }}</el-tag>
                            <el-tag size="mini" effect="plain">后缀: {{ group.suffix || 'T' }}</el-tag>
                            <el-tag v-if="(group.mskus || []).length" size="mini" type="success">{{ group.mskus.length }} 个已生成</el-tag>
                            <el-tag v-else size="mini" type="warning" effect="plain">尚未生成</el-tag>
                        </div>
                        <div class="draft-group-summary">采购总量 {{ group.total_quantity }} · 单个上限 {{ group.quantity_limit }} · 分配总量 {{ draftAllocatedTotal(group) }}<em class="draft-fixed-note">（采购量由采购需求决定，不可修改）</em></div>
                        <div class="draft-group-summary">MSKU 基础名：{{ draftGroupBase(group) || '待填写' }} · 长度 {{ (draftGroupBase(group) || '').length }} / {{ group.max_base_len || 40 }}</div>
                        <el-button type="text" size="mini" @click="toggleDraftOriginalConfig(group)">
                            {{ isDraftOriginalConfigExpanded(group) ? '隐藏' : '显示' }}品名原有配置
                        </el-button>
                        <div v-show="isDraftOriginalConfigExpanded(group)" class="batch-asin-config-preview">
                            <div class="batch-asin-config-item">
                                <span class="batch-asin-config-label">产品类型</span>
                                <span class="batch-asin-config-value" :class="{ 'is-empty': !group.product_type }">{{ draftProductTypeLabel(group.product_type) || '未填写' }}</span>
                            </div>
                            <div class="batch-asin-config-item">
                                <span class="batch-asin-config-label">MSKU颜色 / 供应商</span>
                                <span class="batch-asin-config-value">{{ group.msku_color || '未填写' }} / {{ group.supplier || '未填写' }}</span>
                            </div>
                            <div v-for="field in draftConfigPreviewFields(group)" :key="field.key" class="batch-asin-config-item">
                                <span class="batch-asin-config-label">{{ field.label }}</span>
                                <span class="batch-asin-config-value" :class="{ 'is-empty': draftFieldDisplayText(group, field) === '未填写' }">
                                    {{ draftFieldDisplayText(group, field) }}
                                </span>
                            </div>
                        </div>
                        <div v-if="draftGroupIssue(group)" class="batch-asin-config-empty">{{ draftGroupIssue(group) }}</div>
                        <div class="batch-asin-msku-toggle-row">
                            <span>生成的 MSKU（{{ draftAllocationRows(group).length }}）<em class="batch-asin-msku-field-hint">展开行可查看该产品类型全部字段</em></span>
                            <el-button type="text" size="mini" @click="toggleDraftMskuItem(group)">
                                <i :class="isDraftMskuItemExpanded(group) ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                                {{ isDraftMskuItemExpanded(group) ? '隐藏' : '显示' }}
                            </el-button>
                        </div>
                        <div v-show="isDraftMskuItemExpanded(group)" class="batch-asin-item-mskus">
                        <el-table :data="draftAllocationRows(group)" row-key="detail_id"
                            :expand-row-keys="draftMskuRowKeys" @expand-change="onDraftMskuRowExpand"
                            size="small" max-height="360" border stripe>
                            <el-table-column type="expand" width="46">
                                <template slot-scope="scope">
                                    <div class="draft-row-context">明细 {{ scope.row.detail_id }} · SKU {{ scope.row.sku }} · {{ scope.row.display_shop }} · 仓库 {{ scope.row.warehouse }} · {{ scope.row.product_type }}</div>
                                    <div class="batch-asin-msku-field-grid">
                                        <div v-for="field in draftMskuFieldRows(group, scope.row)" :key="field.key" class="batch-asin-msku-field-item">
                                            <span class="batch-asin-msku-field-label" :title="field.key">
                                                <span v-if="field.required" class="draft-required">* </span>{{ field.label }}
                                            </span>
                                            <span class="batch-asin-msku-field-value"
                                                :class="{ 'is-empty': field.value === '未填写' || field.value === '' }">{{ field.value }}</span>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column type="index" label="#" width="55" align="center" />
                            <el-table-column label="生成的 MSKU" min-width="230" show-overflow-tooltip><template slot-scope="scope">{{ scope.row.msku || '待补配置生成' }}</template></el-table-column>
                            <el-table-column label="主标题" min-width="260" show-overflow-tooltip><template slot-scope="scope">{{ draftFieldDisplayText(scope.row, { key: 'item_name' }) }}</template></el-table-column>
                            <el-table-column label="副标题" min-width="220" show-overflow-tooltip><template slot-scope="scope">{{ draftFieldDisplayText(scope.row, { key: 'title_differentiation' }) }}</template></el-table-column>
                            <el-table-column label="采购分配量" width="120" align="center">
                                <template slot-scope="scope">{{ scope.row.quantity }}</template>
                            </el-table-column>
                        </el-table>
                        </div>
                    </div>
                    </div>
                </div>
            </template>
            <div slot="footer" class="draft-footer">
                <span class="draft-footer-summary">{{ newAsinDraftItems.length }} 个品名 / {{ newAsinDraftItems.reduce((sum, group) => sum + (group.generated_count || 0), 0) }} 个已生成 MSKU<span v-if="newAsinDraft"> · {{ newAsinDraft.status === 'draft' ? '草稿未提交' : '已进入统一任务' }}</span></span>
                <div class="draft-footer-actions">
                    <el-button size="small" @click="newAsinDraftVisible = false">关闭</el-button>
                    <el-button v-if="draftView === 'config'" size="small" type="primary" :loading="newAsinDraftSaving" :disabled="!draftCanEdit" @click="generateProcurementDraft">生成 MSKU 并带出字段</el-button>
                    <template v-if="draftView === 'preview'">
                        <el-button size="small" :disabled="!draftCanEdit" @click="draftView = 'config'">返回配置</el-button>
                        <el-button size="small" type="primary" plain :loading="newAsinDraftSaving" :disabled="!draftCanEdit" @click="exportNewAsinDraft">导出字段 Excel</el-button>
                        <el-button size="small" type="warning" plain :loading="newAsinDraftImporting" :disabled="!draftCanEdit" @click="pickProcurementDraftImport">上传修改后的 Excel</el-button>
                        <el-button size="small" :loading="newAsinDraftSaving" :disabled="!draftCanEdit" @click="saveNewAsinDraft(false)">保存并校验</el-button>
                        <el-button size="small" type="primary" :loading="newAsinDraftConfirming" :disabled="!draftCanEdit || !draftHasGenerated" @click="confirmNewAsinDraft">确认新建 ASIN 采购</el-button>
                    </template>
                </div>
            </div>
        </el-dialog>

        <pm-config-dialog :visible.sync="draftPmConfigVisible"
            :parent="draftConfigMeta.parent" :pm="draftConfigMeta.pm" :shop="draftConfigMeta.shop"
            :msku="draftConfigMeta.msku" :show-warehouse="false"
            @saved="onDraftPmConfigSaved" />
        <parent-config-dialog :visible.sync="draftParentConfigVisible"
            :parent="draftConfigMeta.parent" :parent-list="draftParentOptions"
            @saved="onDraftParentConfigSaved" />
	</div>
</template>

<script>
import ProcurementTaskPanel from './ProcurementTaskPanel.vue'
import MskuGenerationTable from './MskuGenerationTable.vue'
import PmConfigDialog from './PmConfigDialog.vue'
import ParentConfigDialog from './ParentConfigDialog.vue'
// import TaskPanelDialog from './TaskPanelDialog.vue';

export default {
    components: { ProcurementTaskPanel, MskuGenerationTable, PmConfigDialog, ParentConfigDialog },
	data() {
		return {
			searchForm: { shop: '', parentName: '' },
			isSending: false,
			isSending1: false,
			isSending2: false,
			isSending4: false,
			isSending5: false,
			isSending8: false,
			isSending18: false,
			pendingConfigRow: null,
			pendingPurchaseMode: null,
			// 新建 ASIN 的一次性选项（不落库 purchase_mode；源 FNSKU 写入任务元数据）
			sourceFnskuDialogVisible: false,
			sourceFnskuLoading: false,
			sourceFnskuRow: null,
			sourceFnskuOptions: [],
			sourceFnskuValue: '',
			sourceMskuSuffix: 'T',
			sourceMskuCustomSuffix: '',
			sourceFnskuContinue: null,
			isSending_in: false,
			isSending_register: false,
			dialogVisible: false,
			dialogVisible1: false,
			dialogVisible2: false,
			dialogPmConfigVisible: false,
			dialogTaskPanel: false,
			taskList: [],
			activeTaskCount: 0,
			projectname: '',
			projectf: '',
			pmFilter: '',
			skuFilter: '',
			isButtonDisabled: false,
			tableKey: 0,
			fileData: [],
			allParentList: [],
			form: {},
			form1: {
				建议方案: '30天销量/30*备货天数+旺季备货+黑五备货+会员日备货-FBA库存-FBA在途-预计库存'
			},
			size: '',
			title: '',
			visible: false,
			tableData: [],
			tableData1: [],
			tableData2: [],
			tableData3: [],
			tableDataover: [],
			sku: [],
			fnsku: [],
			fnskuLoading: false,
			selectedDate: '',
			num1: 1,
			filters: [{ text: 'CoBak-US', value: 'CoBak-US' }, { text: 'CoBak-UK', value: 'CoBak-UK' }, { text: 'CoBak-SG', value: 'CoBak-SG' }, { text: 'CoBak-SE', value: 'CoBak-SE' }, { text: 'CoBak-PL', value: 'CoBak-PL' }, { text: 'CoBak-NL', value: 'CoBak-NL' }, { text: 'CoBak-MX', value: 'CoBak-MX' }, { text: 'CoBak-JP', value: 'CoBak-JP' }, { text: 'CoBak-IT', value: 'CoBak-IT' }, { text: 'CoBak-INDIA-IN', value: 'CoBak-INDIA-IN' }, { text: 'CoBak-FR', value: 'CoBak-FR' }, { text: 'CoBak-ES', value: 'CoBak-ES' }, { text: 'CoBak-DE', value: 'CoBak-DE' }, { text: 'CoBak-CA', value: 'CoBak-CA' }, { text: 'CoBak-BR', value: 'CoBak-BR' }, { text: 'CoBak Direct-BE', value: 'CoBak Direct-BE' }, { text: 'SMIFACE-CA', value: 'SMIFACE-CA' }, { text: 'SMIFACE-US', value: 'SMIFACE-US' }, { text: 'IDLEHANDS-US-CA', value: 'IDLEHANDS-US-CA' }, { text: 'iDLEHANDS-US-MX', value: 'iDLEHANDS-US-MX' }, { text: 'iDLEHANDS-US-US', value: 'iDLEHANDS-US-US' }, { text: 'European Union', value: 'EU' }],
			filterText: '',
			cangku: [{ text: '百汇办公室', value: '百汇办公室' }, { text: '工厂仓库', value: '工厂仓库' }, { text: '横中路仓库-加拿大', value: '横中路仓库-加拿大' }, { text: '横中路仓库-日本', value: '横中路仓库-日本' }, { text: '横中路仓库-美国', value: '横中路仓库-美国' }, { text: '横中路仓库-英国', value: '横中路仓库-英国' }, { text: '横中路仓库-德国', value: '横中路仓库-德国' }, { text: '淘汰-横中路成品仓库-加拿大', value: '淘汰-横中路成品仓库-加拿大' }, { text: '淘汰-横中路成品仓库-日本', value: '淘汰-横中路成品仓库-日本' }, { text: '淘汰-横中路成品仓库-美国', value: '淘汰-横中路成品仓库-美国' }, { text: '淘汰-横中路成品仓库-英国', value: '淘汰-横中路成品仓库-英国' }, { text: '批发仓库', value: '批发仓库' }, { text: '横中路仓库-印度', value: '横中路仓库-印度' }, { text: '横中路仓库-公共', value: '横中路仓库-公共' }],
			value: '',
			visible1: false,
			value1: [],
			value2: [],
			value3: [],
			test: [],
			formLabelWidth: '80px',
			timer: null,
			named: '',
			fand: 0,
			store: [],
			flagnum: 0,
			pmConfigMeta: { '本地父体': '', '本地品名': '', '店铺': '', msku: '', warehouse: '' },
			// 混合采购与新建 ASIN 草稿状态；request/draft 标识同时写入浏览器，
			// 页面刷新后可以继续查询原结果，不会因为前端重试而再次提交。
			purchaseSelection: [],
			procurementResultVisible: false,
			procurementResult: null,
			procurementRequestId: '',
			newAsinRequirementVisible: false,
			newAsinRequirementSaving: false,
			newAsinRequirementSkuLoading: false,
			newAsinRequirementSkuOptions: [],
			newAsinRequirementRow: null,
			// 需求弹窗所属店铺的采购上下文（锁定仓库）。
			newAsinRequirementContext: {},
			newAsinRequirementForm: {
				parent: '', pm: '', shop: '', sku: '', warehouse: '',
				total_quantity: 0, quantity_limit: 0,
			},
			// FNSKU 已忽略清单（后端 ignore_fnsku）：支持恢复，不再单向隐藏。
			fnskuIgnored: [],
			// 店铺采购上下文（站点→锁定仓库）与 FNSKU 请求竞态序号。
			procurementContext: {},
			fnskuReqToken: 0,
			purchaseTemplatePreviewVisible: false,
			purchaseTemplatePreview: null,
			purchaseTemplateApplying: false,
			newAsinDraftVisible: false,
			newAsinDraft: null,
            draftView: 'config',
            draftBatchProductType: '',
            // 生成 MSKU 界面与 Auto 批量新建ASIN 一致：每个品名的
            // 「品名原有配置」和「生成的 MSKU」各自独立展开/收起。
            draftMskuExpandedItems: [],
            // 展开字段详情的 MSKU 行（detail_id）：由“显示/全部显示”统一控制。
            draftMskuRowKeys: [],
            draftOriginalConfigExpanded: [],
            procurementProductTypes: [],
            newAsinDraftSaving: false,
			newAsinDraftConfirming: false,
			newAsinDraftImporting: false,
            draftPmConfigVisible: false,
            draftParentConfigVisible: false,
            draftConfigMeta: { parent: '', pm: '', shop: '', msku: '', rowKey: '' },
            draftLengthBudgetToken: 0,
            draftLengthBudgetLoading: false,
            draftGenerationOperationId: '',
            draftSavedGenerationSignature: '',
		}
	},
	mounted() {
		// 暂时关闭任务面板的后台轮询，页面仅保留原有采购流程。
		// this._resumePolling()

		this.loadParentList()
		this.restoreProcurementContext()
	},
	computed: {
		// FNSKU 下拉展示顺序：可选项在前，已忽略项排在最后（仍可见，点右侧按钮恢复）。
		fnskuOptions() {
			const normal = (this.fnsku || []).map(item => ({ ...item, _ignored: false }))
			const ignored = (this.fnskuIgnored || []).map(item => ({ ...item, _ignored: true }))
			return normal.concat(ignored)
		},
		// 仓库由店铺唯一确定：有锁定仓库时明细只读，未配置站点则禁止采购。
		lockedWarehouse() {
			return (this.procurementContext && this.procurementContext.warehouse) || '';
		},
		newAsinRequirementLockedWarehouse() {
			const ctx = this.newAsinRequirementContext || {};
			return ctx.warehouse || '';
		},
        draftHasGenerated() {
            return this.newAsinDraftItems.length > 0 && this.newAsinDraftItems.every(group => !group.generation_stale
                && this.draftAllocationRows(group).length > 0
                && this.draftAllocationRows(group).every(row => !!row.msku))
                && !this.draftGenerationConfigDirty()
        },
        draftCanEdit() {
            return !!this.newAsinDraft && this.newAsinDraft.status === 'draft' && !this.newAsinDraftSaving && !this.newAsinDraftImporting && !this.newAsinDraftConfirming
        },
		parentOptions() {
			return (this.allParentList || []).map(p => ({
				text: p['本地父体'] || '', value: p['本地父体'] || ''
			}));
		},
		filteredTableData() {
			let data = this.tableData1 || [];
			const pmKw = this.pmFilter.toLowerCase();
			const skuKw = this.skuFilter.toLowerCase();
			if (pmKw) data = data.filter(r => (r['本地品名'] || '').toLowerCase().includes(pmKw));
			if (skuKw) data = data.filter(r => (r.sku || '').toLowerCase().includes(skuKw));
			return data;
		},
		// 单个 ASIN 采购数量（上限）的最小值：新建 ASIN 采购需求弹窗的输入下限与默认值。
		minAsinQuantityLimit() {
			return 10
		},
		newAsinRequirementCount() {
			const total = this.toPositiveInteger(this.newAsinRequirementForm.total_quantity)
			const limit = this.toPositiveInteger(this.newAsinRequirementForm.quantity_limit)
			return total && limit ? Math.ceil(total / limit) : 0
		},
		newAsinRequirementAllocations() {
			const total = this.toPositiveInteger(this.newAsinRequirementForm.total_quantity)
			const limit = this.toPositiveInteger(this.newAsinRequirementForm.quantity_limit)
			const count = this.newAsinRequirementCount
			let remaining = total
			return Array.from({ length: count }, (_, index) => {
				const quantity = Math.min(limit, remaining)
				remaining -= quantity
				return { index: index + 1, quantity }
			})
		},
		newAsinRequirementAssigned() {
			return this.newAsinRequirementAllocations.reduce((sum, row) => sum + Number(row.quantity || 0), 0)
		},
		newAsinDraftItems() {
			return this.newAsinDraft && this.newAsinDraft.plan
				? (this.newAsinDraft.plan.items || []) : []
		},
        draftParentOptions() {
            return this.draftConfigMeta.parent
                ? [{ '本地父体': this.draftConfigMeta.parent }]
                : []
        },
        draftGenerationTableActions() {
            return {
                genMultiRowClass: this.draftGenerationRowClass,
                genMultiRowIssue: this.draftGroupIssue,
                genRowShouldPair: () => true,
                genSkuOptionLabel: (row, sku) => String(sku || ''),
                isGenSkuDetailLoading: () => false,
                onGenRowSkuChange: () => {},
                onGenRowSkuInput: () => {},
                loadGenRowSkuDetail: () => {},
                onGenRowSuffixChange: () => {},
                onGenRowPairChange: () => {},
                onGenRowColorChange: this.onDraftGenerationColorChange,
                onGenRowSupplierChange: this.onDraftGenerationSupplierChange,
                onGenRowCountryChange: this.onDraftGenerationCountryChange,
                onGenRowModeChange: this.onDraftGenerationModeChange,
                genRowOverlong: this.draftGenerationRowOverlong,
                genRowBase: this.draftGenerationRowBase,
                startGenRowEdit: this.startDraftGenerationBaseEdit,
                saveGenRowBaseEdit: this.saveDraftGenerationBaseEdit,
                resetGenRowBase: this.resetDraftGenerationBase,
                onGenMultiRowCommand: this.onDraftGenerationRowCommand,
                onBatchAsinProductTypeChange: this.onDraftProductTypeChange,
                quantityChange: () => {},
            }
        },
		procurementResultAlertType() {
			const result = this.procurementResult || {}
			// 有品名被他人草稿占用时本次并未全部处理，优先提示警告而不是成功。
			if ((result.occupied_items || []).length) return 'warning'
			if (result.new_asin_draft) {
				return result.normal && ['failed', 'partial_failed', 'result_unknown'].includes(result.normal.status)
					? 'warning' : 'success'
			}
			if (result.new_asin_error) return 'warning'
			if (result.status === 'failed') return 'error'
			if (result.status === 'partial_failed' || result.status === 'result_unknown') return 'warning'
			return 'info'
		},
		procurementResultAlertTitle() {
			const result = this.procurementResult || {}
			if (result.status === 'result_unknown' || (result.normal && result.normal.status === 'result_unknown')) {
				return '结果待核查：系统不会自动重发普通采购'
			}
			if (result.new_asin_draft) return '普通采购结果已记录，新建 ASIN 草稿可继续配置'
			return result.message || '一键采购已处理'
		},
	},
	methods: {
		toPositiveInteger(value) {
			if (value === null || value === undefined || value === '' || typeof value === 'boolean') return 0
			const number = Number(value)
			return Number.isFinite(number) && Math.floor(number) === number && number > 0 ? number : 0
		},
		newProcurementRequestId(prefix = 'pc') {
			return `${prefix}_${Date.now()}_${Math.random().toString(16).slice(2, 12)}`
		},
		restoreProcurementContext() {
		try {
			const requestId = window.localStorage.getItem('parent_calculate_procurement_request_id')
			const draftId = window.localStorage.getItem('parent_calculate_procurement_draft_id')
			if (requestId) {
				this.procurementRequestId = requestId
				this.fetchProcurementRequest(requestId, false)
			}
			if (draftId) this.openNewAsinDraft({ draft_id: draftId }, false)
		} catch (error) {
			// 隐私模式/禁用 localStorage 不应阻断页面正常使用。
			console.warn('恢复采购上下文失败', error)
		}
		},
		persistProcurementContext(requestId, draftId = '') {
			try {
				if (requestId) window.localStorage.setItem('parent_calculate_procurement_request_id', requestId)
				if (draftId) window.localStorage.setItem('parent_calculate_procurement_draft_id', draftId)
			} catch (error) {
				console.warn('保存采购上下文失败', error)
			}
		},
		onPurchaseSelectionChange(selection) {
			this.purchaseSelection = selection || []
		},
		downloadBlob(response, filename) {
			const blob = new Blob([response], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			})
			const url = URL.createObjectURL(blob)
			const link = document.createElement('a')
			link.href = url
			link.download = filename
			link.style.display = 'none'
			document.body.appendChild(link)
			link.click()
			setTimeout(() => {
				document.body.removeChild(link)
				URL.revokeObjectURL(url)
			}, 300)
		},
		applyRequirementRowsToTable(rows) {
			const byKey = {}
			;(rows || []).forEach(row => {
				byKey[this.purchaseRowKey(row)] = row
			})
			const patch = row => {
				const saved = byKey[this.purchaseRowKey(row)]
				if (!saved) return row
				return {
					...row,
					'sku': saved.sku,
					'fnsku': saved.fnsku,
					'仓库': saved.warehouse,
					'指定采购数量': saved.total_quantity,
					'每个ASIN采购数量': saved.quantity_limit,
					'采购开关': '启用一键采购',
					'是否使用新ASIN': saved.purchase_mode === 'new_asin'
						? '工具自动生成新ASIN' : '工具使用目前选择FNSKU',
					'purchase_mode': saved.purchase_mode,
				}
			}
			this.tableData1 = (this.tableData1 || []).map(patch)
			this.tableData3 = (this.tableData3 || []).map(patch)
		},
		downloadProcurementRequirementTemplate() {
			this.$axios.get('/vue/parent_calculate/procurement-template/empty', { responseType: 'blob' })
				.then(res => this.downloadBlob(res, '采购需求模板.xlsx'))
				.catch(() => this.$message.error('采购需求模板下载失败'))
		},
		exportProcurementRequirements() {
			if (!this.purchaseSelection.length) return this.$message.warning('请先勾选要导出的采购需求行')
			this.$axios.post('/vue/parent_calculate/procurement-template/export', {
				rows: this.purchaseSelection,
			}, { responseType: 'blob' }).then(res => {
				this.downloadBlob(res, '采购需求预填模板.xlsx')
			}).catch(() => this.$message.error('采购需求导出失败'))
		},
		pickProcurementRequirementImport() {
			if (this.$refs.procurementRequirementFile) this.$refs.procurementRequirementFile.click()
		},
		onProcurementRequirementFilePicked(event) {
			const file = event && event.target && event.target.files && event.target.files[0]
			if (!file) return
			const form = new FormData()
			form.append('file', file)
			this.$axios.post('/vue/parent_calculate/procurement-template/import-preview', form, {
				headers: { 'Content-Type': 'multipart/form-data' },
			}).then(res => {
				if (res.msg === 'success' && res.data) {
					this.purchaseTemplatePreview = res.data
					this.purchaseTemplatePreviewVisible = true
				} else this.$message.error((res && res.message) || '采购需求模板校验失败')
			}).catch(error => this.$message.error((error && error.message) || '采购需求模板校验失败'))
			if (event.target) event.target.value = ''
		},
		applyProcurementRequirementImport() {
			if (!this.purchaseTemplatePreview || this.purchaseTemplatePreview.summary.invalid > 0) return
			this.purchaseTemplateApplying = true
			this.$axios.post('/vue/parent_calculate/procurement-template/import-apply', {
				rows: this.purchaseTemplatePreview.rows,
				preview_token: this.purchaseTemplatePreview.preview_token,
			}).then(res => {
				if (res.msg !== 'success') throw new Error(res.message || '保存采购需求失败')
				this.applyRequirementRowsToTable((res.data && res.data.rows) || this.purchaseTemplatePreview.rows)
				this.purchaseTemplatePreviewVisible = false
				this.$message.success('采购需求已保存，可继续混合采购')
			}).catch(error => this.$message.error(error.message || '保存采购需求失败'))
				.finally(() => { this.purchaseTemplateApplying = false })
		},
		loadNewAsinRequirementSkus(pm, selectedSku = '') {
			this.newAsinRequirementSkuOptions = []
			if (!pm) return
			this.newAsinRequirementSkuLoading = true
			this.$axios.post('/vue/parent_calculate/select_sku', { pm }).then(res => {
				if (!res || res.msg !== 'success') throw new Error((res && res.data) || '未获取到该品名对应的 SKU')
				const options = (res.data || []).map(item => ({
					...item,
					value: item.value || item.SKU,
				}))
				if (selectedSku && !options.some(item => item.value === selectedSku)) {
					options.unshift({ SKU: selectedSku, value: selectedSku })
				}
				this.newAsinRequirementSkuOptions = options
			}).catch(error => {
				this.newAsinRequirementSkuOptions = selectedSku
					? [{ SKU: selectedSku, value: selectedSku }] : []
				this.$message.warning((error && error.message) || 'SKU列表加载失败，请重新打开弹窗')
			}).finally(() => {
				this.newAsinRequirementSkuLoading = false
			})
		},
		openNewAsinRequirement(row) {
			const specified = this.toPositiveInteger(row && row['指定采购数量'])
			const suggestion = this.toPositiveInteger(row && row['备货建议'])
			const total = specified || suggestion
			// 单个 ASIN 上限最小 10：已配置的更小值也按最小值兜底。
			const existingLimit = this.toPositiveInteger(row && row['每个ASIN采购数量'])
			const selectedSku = row.sku || row.SKU || ''
			this.newAsinRequirementRow = row
			this.newAsinRequirementForm = {
				parent: row['本地父体'] || '', pm: row['本地品名'] || '',
				shop: row['店铺'] || this.filterText || '', sku: selectedSku,
				warehouse: row['仓库'] || '', total_quantity: total,
				quantity_limit: Math.max(this.minAsinQuantityLimit, existingLimit),
			}
			this.newAsinRequirementVisible = true
			// 仓库由店铺站点锁定，打开弹窗即带出并置为只读。
			this.loadProcurementContext(this.newAsinRequirementForm.shop, 'requirement')
			this.loadNewAsinRequirementSkus(this.newAsinRequirementForm.pm, selectedSku)
		},
		saveNewAsinRequirement() {
			const form = this.newAsinRequirementForm
			const total = this.toPositiveInteger(form.total_quantity)
			const limit = this.toPositiveInteger(form.quantity_limit)
			if (!total || !limit) return this.$message.warning('采购总量和单个 ASIN 上限必须是正整数')
			if (limit < this.minAsinQuantityLimit) {
				return this.$message.warning(`单个 ASIN 数量上限不能小于 ${this.minAsinQuantityLimit}`)
			}
			if (!form.sku) return this.$message.warning('新建 ASIN 采购必须填写 SKU')
			if (!form.warehouse) return this.$message.warning('请选择仓库')
			this.newAsinRequirementSaving = true
			this.$axios.post('/vue/parent_calculate/procurement-requirement', {
				...form, purchase_mode: 'new_asin', total_quantity: total, quantity_limit: limit,
			}).then(res => {
				if (res.msg !== 'success') throw new Error(res.message || '保存采购需求失败')
				const saved = (res.data && res.data.rows && res.data.rows[0]) || form
				this.applyRequirementRowsToTable([saved])
				this.newAsinRequirementVisible = false
				this.$message.success('新建 ASIN 采购需求已启用')
			}).catch(error => this.$message.error(error.message || '保存采购需求失败'))
				.finally(() => { this.newAsinRequirementSaving = false })
		},
		fetchProcurementRequest(requestId, showDialog = true) {
			if (!requestId) return
			this.$axios.get('/vue/parent_calculate/procurement-request', { params: { request_id: requestId } })
				.then(res => {
					if (res.msg === 'success' && res.data) {
						this.procurementResult = res.data
						this.procurementRequestId = res.data.request_id || requestId
						if (res.data.new_asin_draft) this.persistProcurementContext(requestId, res.data.new_asin_draft.draft_id)
						if (showDialog) this.procurementResultVisible = true
					}
				}).catch(error => {
					if (showDialog) this.$message.error(error.message || '采购结果查询失败')
				})
		},
		draftConfigObject(group) {
			if (!group) return {}
			if (!group.draft_config || typeof group.draft_config !== 'object') {
				this.$set(group, 'draft_config', {})
			}
			return group.draft_config
		},
		draftConfigValue(group, key, fallback = '') {
			const config = this.draftConfigObject(group)
			if (config[key] !== undefined && config[key] !== null) return config[key]
			if (group && group[key] !== undefined && group[key] !== null) return group[key]
			return fallback
		},
		draftGenerationFields() {
			return ['mode', 'msku_color', 'msku_template', 'series', 'style',
				'msku_separator', 'base', 'base_override', 'supplier', 'country',
				'product_type']
		},
		draftGenerationConfigForSignature(group) {
			const config = this.draftConfigObject(group)
			return this.draftGenerationFields().reduce((result, key) => {
				let value = config[key]
				if (value === undefined || value === null) value = group && group[key]
				if (key === 'country') value = String(value || '').trim().toUpperCase()
				else if (value && typeof value === 'object') value = JSON.stringify(value)
				else value = String(value || '').trim()
				result[key] = value
				return result
			}, {})
		},
		draftGenerationSignature() {
			return JSON.stringify(this.newAsinDraftItems.map(group => ({
				key: this.draftGroupKey(group),
				config: this.draftGenerationConfigForSignature(group),
			})))
		},
		draftGenerationConfigDirty() {
			return !!this.draftSavedGenerationSignature
				&& this.draftGenerationSignature() !== this.draftSavedGenerationSignature
		},
		syncDraftGenerationRow(group, preferRow = false) {
			if (!group) return
			const config = this.draftConfigObject(group)
			const fields = this.draftGenerationFields()
			fields.forEach(key => {
				let value = preferRow ? group[key] : config[key]
				if (value === undefined || value === null || value === '') value = preferRow ? config[key] : group[key]
				if (key === 'country') value = String(value || '').trim().toUpperCase()
				else if (key === 'msku_color') value = this.draftColorText(value)
				else value = value === undefined || value === null ? '' : value
				this.$set(config, key, value)
			})
			const mode = ['template', 'attribute'].includes(String(config.mode || '').trim())
				? String(config.mode).trim() : 'template'
			this.$set(config, 'mode', mode)
			this.$set(group, 'mode', mode)
			this.$set(group, 'msku_color', this.draftColorText(config.msku_color))
			this.$set(group, 'msku_template', String(config.msku_template || '').trim())
			this.$set(group, 'series', String(config.series || '').trim())
			this.$set(group, 'style', String(config.style || '').trim())
			this.$set(group, 'msku_separator', String(config.msku_separator || '-').trim() || '-')
			this.$set(group, 'supplier', String(config.supplier || '').trim())
			this.$set(group, 'country', String(config.country || '').trim().toUpperCase())
			this.$set(group, 'product_type', String(config.product_type || '').trim())
			this.$set(group, 'product_type_choice', group.product_type)
			this.$set(group, 'product_type_override', group.product_type)
			this.$set(group, 'base_override', String(config.base_override || '').trim())
			this.$set(group, 'base', this.draftGenerationRowBase(group))
			this.$set(config, 'base_override', group.base_override)
			this.$set(config, 'base', group.base)
			this.$set(group, 'suffix', 'T')
			this.$set(group, 'should_pair', true)
			this.$set(group, 'num', this.draftAllocationRows(group).length)
			if (!Array.isArray(group.skus) || !group.skus.length) this.$set(group, 'skus', group.sku ? [group.sku] : [])
		},
		syncDraftGenerationRows() {
			this.newAsinDraftItems.forEach(group => {
				if (!group._draftManualFields) this.$set(group, '_draftManualFields', {})
				this.syncDraftGenerationRow(group)
			})
			const types = [...new Set(this.newAsinDraftItems
				.map(group => String(group.product_type || '').trim()).filter(Boolean))]
			this.draftBatchProductType = types.length === 1 ? types[0] : ''
			this.$nextTick(() => {
				if (this.$refs.procurementDraftGenerationTable
					&& this.$refs.procurementDraftGenerationTable.doLayout) {
					this.$refs.procurementDraftGenerationTable.doLayout()
				}
			})
		},
		draftColorText(value) {
			if (value && typeof value === 'object') {
				return String(value['配置颜色'] || value['品名颜色'] || value['英文翻译'] || '').trim()
			}
			return String(value || '').trim()
		},
		draftGenerationMissingFields(group) {
			if (!group) return []
			const missing = []
			if (!String(group.parent || '').trim()) missing.push('本地父体')
			if (!String(group.pm || '').trim()) missing.push('本地品名')
			if (!String(group.shop || '').trim()) missing.push('店铺')
			const mode = String(group.mode || '').trim()
			if (mode === 'template') {
				if (!String(group.msku_template || '').trim()) missing.push('MSKU模板')
			} else if (mode === 'attribute') {
				if (!String(group.series || '').trim()) missing.push('系列')
				if (!String(group.style || '').trim()) missing.push('款式')
				if (!String(group.msku_color || '').trim()) missing.push('MSKU颜色')
			} else {
				missing.push('生成模式')
			}
			if (!String(group.country || '').trim()) missing.push('国家代码')
			if (!String(group.supplier || '').trim()) missing.push('供应商')
			if (!String(group.product_type || '').trim()) missing.push('产品类型')
			if (String(group.sku || '').trim() === '') missing.push('关联 SKU')
			return [...new Set(missing)]
		},
		draftProductTypeConflict() {
			const values = [...new Set(this.newAsinDraftItems
				.map(group => String(group.product_type || '').trim()).filter(Boolean))]
			return values.length > 1 ? values : []
		},
		draftGenerationConfigIssue(group) {
			if (!group) return ''
			if (group.config_error) return String(group.config_error)
			if (group.lengthBudgetError) return String(group.lengthBudgetError)
			const base = this.draftGenerationRowBase(group)
			if (this.draftGenerationRowOverlong(group)) {
				return `基础名 ${base.length} 字符超出最大 ${group.max_base_len} 字符，请编辑基础名预览`
			}
			const missing = this.draftGenerationMissingFields(group)
			if (missing.length) return '缺少：' + missing.join('、')
			const conflict = this.draftProductTypeConflict()
			if (conflict.length) return '本批次产品类型必须一致：' + conflict.join('、')
			return ''
		},
		draftGroupIssue(group) {
			if (!group) return ''
			if (group.generation_stale) return '生成配置已修改，旧 MSKU 预览已失效，请重新生成'
			const configIssue = this.draftGenerationConfigIssue(group)
			if (configIssue) return configIssue
			if ((group.preparation_errors || []).length) return group.preparation_errors[0]
			if (group.generation_pending || this.draftAllocationRows(group).some(row => !row.msku)) {
				return '尚未生成 MSKU，请补齐配置后点击生成'
			}
			return ''
		},
		draftGenerationRowClass({ row }) {
			return this.draftGroupIssue(row) ? 'gen-multi-issue-row' : ''
		},
		draftGenerationRowBase(row) {
			if (!row) return ''
			const override = String(row.base_override || '').trim()
			if (override) return override
			const mode = String(row.mode || '').trim()
			if (mode === 'template') return String(row.msku_template || row.configured_base || row.base || '').trim()
			if (mode === 'attribute') {
				const separator = String(row.msku_separator || '-').trim() || '-'
				const parts = [row.series, row.style, row.msku_color]
					.map(value => String(value || '').trim()).filter(Boolean)
				if (parts.length) return parts.join(separator)
			}
			return String(row.configured_base || row.base || '').trim()
		},
		draftGenerationRowOverlong(row) {
			const max = Number(row && row.max_base_len || 0)
			return !!(max > 0 && this.draftGenerationRowBase(row).length > max)
		},
		markDraftGenerationField(row, field) {
			if (!row) return
			if (!row._draftManualFields) this.$set(row, '_draftManualFields', {})
			this.$set(row._draftManualFields, field, true)
		},
		markDraftGenerationConfigDirty(row) {
			this.syncDraftGenerationRow(row, true)
			this.refreshDraftLengthBudgets()
		},
		onDraftGenerationColorChange(row) {
			if (!row) return
			this.$set(row, 'msku_color', this.draftColorText(row.msku_color))
			this.markDraftGenerationField(row, 'msku_color')
			this.$set(row, 'color', row.msku_color)
			if (row.mode !== 'template') this.resetDraftGenerationBase(row, false)
			this.markDraftGenerationConfigDirty(row)
		},
		onDraftGenerationSupplierChange(row) {
			if (!row) return
			this.markDraftGenerationField(row, 'supplier')
			this.markDraftGenerationConfigDirty(row)
		},
		onDraftGenerationCountryChange(row) {
			if (!row) return
			this.$set(row, 'country', String(row.country || '').trim().toUpperCase())
			this.markDraftGenerationField(row, 'country')
			this.markDraftGenerationConfigDirty(row)
		},
		onDraftGenerationModeChange(row) {
			if (!row) return
			this.$set(row, 'mode', ['template', 'attribute'].includes(row.mode) ? row.mode : 'template')
			this.markDraftGenerationField(row, 'mode')
			this.resetDraftGenerationBase(row, false)
			this.markDraftGenerationConfigDirty(row)
		},
		startDraftGenerationBaseEdit(row) {
			if (!row) return
			this.$set(row, '_baseDraft', this.draftGenerationRowBase(row))
			this.$set(row, '_baseEditing', true)
		},
		saveDraftGenerationBaseEdit(row) {
			if (!row) return
			const draft = String(row._baseDraft || '').trim()
			const automatic = this.draftGenerationRowBase({
				...row, base_override: '',
			})
			this.$set(row, 'base_override', draft === automatic ? '' : draft)
			this.$set(row, '_baseEditing', false)
			this.markDraftGenerationField(row, 'base')
			this.markDraftGenerationConfigDirty(row)
		},
		resetDraftGenerationBase(row, markManual = true) {
			if (!row) return
			this.$set(row, 'base_override', '')
			this.$set(row, '_baseDraft', '')
			this.$set(row, '_baseEditing', false)
			if (markManual) this.markDraftGenerationField(row, 'base')
			this.syncDraftGenerationRow(row, true)
		},
			onDraftProductTypeChange(row) {
				if (!row) return
				const value = String(row.product_type_choice || '').trim()
				this.$set(row, 'product_type', value)
				this.$set(row, 'product_type_override', value)
				this.markDraftGenerationField(row, 'product_type')
				this.markDraftGenerationConfigDirty(row)
			},
			onDraftGenerationRowCommand(command, row) {
				if (command === 'config') return this.openDraftPmConfig(row)
				if (command === 'parentConfig') return this.openDraftParentConfig(row)
			},
			openDraftPmConfig(row) {
				if (!row) return
				this.draftConfigMeta = {
					parent: row.parent || '', pm: row.pm || '', shop: row.shop || '',
					msku: (row.mskus && row.mskus[0]) || '', rowKey: this.draftGroupKey(row),
				}
				this.draftPmConfigVisible = true
			},
			openDraftParentConfig(row) {
				if (!row) return
				this.draftConfigMeta = {
					parent: row.parent || '', pm: row.pm || '', shop: row.shop || '',
					msku: (row.mskus && row.mskus[0]) || '', rowKey: this.draftGroupKey(row),
				}
				this.draftParentConfigVisible = true
			},
			onDraftPmConfigSaved() {
				this.draftPmConfigVisible = false
				return this.reloadDraftGenerationConfig(this.draftConfigMeta.rowKey)
			},
			onDraftParentConfigSaved() {
				this.draftParentConfigVisible = false
				return this.reloadDraftGenerationConfig()
			},
			reloadDraftGenerationConfig(rowKey = '') {
				if (!this.draftCanEdit || !this.newAsinDraftItems.length) return Promise.resolve()
				const rows = this.newAsinDraftItems.filter(row => !rowKey || this.draftGroupKey(row) === rowKey)
				if (!rows.length) return Promise.resolve()
				const items = rows.map(row => {
					const manual = row._draftManualFields || {}
					const item = {
						parent: row.parent, pm: row.pm, shop: row.shop, sku: row.sku,
						num: this.draftAllocationRows(row).length, suffix: 'T',
						config_overrides: {}, upload_overrides: {},
					}
					if (manual.mode) item.mode = row.mode
					if (manual.msku_color) item.msku_color = row.msku_color
					if (manual.supplier) item.supplier = row.supplier
					if (manual.country) item.country = row.country
					if (manual.base) item.base_override = row.base_override || ''
					if (manual.product_type) item.product_type_override = row.product_type || ''
					return item
				})
				this.draftLengthBudgetLoading = true
				return this.$axios.post('/vue/vue_product/batch-asin/prepare', {
					items, suffix: 'T',
				}).then(res => {
					if (res.code !== 200 || !res.data) throw new Error(res.message || '配置重新带出失败')
					;(res.data.results || []).forEach((cfg, index) => {
						const row = rows[index]
						if (!row) return
						const manual = row._draftManualFields || {}
						// 服务端读取失败时返回的是空配置，写回草稿会把已保存的品名
						// 规则清空；这里只保留错误提示，等配置可读后再重新带出。
						if (cfg.config_error) {
							this.$set(row, 'config_error', cfg.config_error)
							this.$message.warning(row.pm + '：' + cfg.config_error)
							return
						}
						const replaceable = [
							'mode', 'msku_color', 'msku_template', 'series', 'style',
							'msku_separator', 'supplier', 'country', 'configured_base',
							'base', 'country_abbr', 'max_base_len', 'length_budget',
							'config_error', 'product_type_source', 'fields', 'field_values',
							'titles', 'title_main_base', 'title_sub_base', 'title_color',
						]
						replaceable.forEach(key => {
							if (cfg[key] !== undefined && !manual[key]) this.$set(row, key, cfg[key])
						})
						if (manual.msku_color) this.$set(row, 'msku_color', this.draftColorText(row.msku_color))
						if (manual.supplier) this.$set(row, 'supplier', String(row.supplier || '').trim())
						if (manual.country) this.$set(row, 'country', String(row.country || '').trim().toUpperCase())
						if (manual.base) {
							this.$set(row, 'base_override', String(row.base_override || '').trim())
						} else {
							this.$set(row, 'base_override', '')
						}
						if (manual.product_type) {
							this.$set(row, 'product_type', String(row.product_type || '').trim())
							this.$set(row, 'product_type_choice', row.product_type)
							this.$set(row, 'product_type_override', row.product_type)
						} else {
							this.$set(row, 'product_type', String(cfg.product_type || '').trim())
							this.$set(row, 'product_type_choice', row.product_type)
							this.$set(row, 'product_type_override', '')
						}
						// 服务端重新带出的值必须同步写回 draft_config：syncDraftGenerationRow
						// 以 draft_config 为准，草稿里的旧快照会覆盖刚带出的品名规则，
						// 导致保存品名配置后表格和草稿内容看起来没有任何变化。
						const config = this.draftConfigObject(row)
						this.draftGenerationFields().forEach(key => {
							if (row[key] !== undefined && row[key] !== null) this.$set(config, key, row[key])
						})
						this.syncDraftGenerationRow(row)
					})
					this.refreshDraftLengthBudgets()
					return this.saveNewAsinDraft(true, false).then(() => {
						this.$message.success('长期配置已保存，草稿配置已重新带出')
					})
				}).catch(error => this.$message.error(error.message || '配置重新带出失败'))
					.finally(() => { this.draftLengthBudgetLoading = false })
			},
			refreshDraftLengthBudgets() {
				const rows = this.newAsinDraftItems || []
				if (!rows.length) {
					this.draftLengthBudgetLoading = false
					return Promise.resolve()
				}
				const requestToken = ++this.draftLengthBudgetToken
				this.draftLengthBudgetLoading = true
				return this.$axios.post('/vue/msku-generation/length-budget/batch', {
					suffix: 'T',
					items: rows.map(row => ({
						supplier: row.supplier || '', country: row.country || '', suffix: 'T',
					})),
				}).then(res => {
					if (requestToken !== this.draftLengthBudgetToken) return
					const budgets = res && res.data && res.data.results
					if (!Array.isArray(budgets)) return
					budgets.forEach(item => {
						const row = rows[item.index]
						if (!row) return
						if (item.error) this.$set(row, 'lengthBudgetError', item.error)
						else {
							this.$set(row, 'lengthBudgetError', '')
							this.$set(row, 'max_base_len', item.max_base_len || 0)
							this.$set(row, 'length_budget', item)
						}
					})
				}).catch(() => {
					// The backend generation validation remains authoritative if the
					// optional live budget endpoint is unavailable.
				}).finally(() => {
					if (requestToken === this.draftLengthBudgetToken) this.draftLengthBudgetLoading = false
				})
			},
		applyDraftProductType(value) {
			this.newAsinDraftItems.forEach(group => {
				this.$set(group, 'product_type_choice', value || '')
				this.onDraftProductTypeChange(group)
			})
		},
		generateProcurementDraft() {
			if (!this.draftCanEdit) return Promise.resolve()
			if (this.draftLengthBudgetLoading) return this.$message.warning('正在计算 MSKU 长度预算，请稍候再生成')
			const issue = this.newAsinDraftItems.map(group => this.draftGenerationConfigIssue(group)).find(Boolean)
			if (issue) return this.$message.warning('请先修正配置：' + issue)
			const hasOldPreview = this.newAsinDraftItems.some(group =>
				this.draftAllocationRows(group).some(row => !!row.msku))
			const proceed = () => {
				// 配置改动后必须换新的操作号：同一个 generation_operation_id 会被后端
				// 当作“同一次生成的重试”直接返回旧结果，表现为重新生成但 MSKU 没变。
				if (!this.draftGenerationOperationId
					|| this.draftGenerationSignature() !== this.draftSavedGenerationSignature) {
					this.draftGenerationOperationId = this.newProcurementRequestId('pcgen')
				}
				return this.saveNewAsinDraft(true, true, true).then(() => {
					if (this.draftHasGenerated && !this.newAsinDraftItems.some(group => this.draftGenerationConfigIssue(group))) {
						this.draftView = 'preview'
						this.expandDraftMskuItems()
					} else {
						this.draftView = 'config'
						this.$message.warning('请修正品名配置后重新生成，旧预览已保留但不能确认')
					}
				}).catch(error => this.$message.error(error.message || '生成 MSKU 失败'))
			}
			if (!hasOldPreview) return proceed()
			return this.$confirm('重新生成会替换旧 MSKU 和逐 MSKU 刊登字段，但会保留采购明细、需求和分配量，是否继续？', '重新生成确认', {
			confirmButtonText: '重新生成', cancelButtonText: '取消', type: 'warning',
			}).then(proceed).catch(() => {})
		},
        // 与 Auto 批量新建ASIN 同一套展开/收起状态：品名原有配置与生成的 MSKU 分开控制。
        isDraftMskuItemExpanded(group) {
            return this.draftMskuExpandedItems.includes(this.draftGroupKey(group))
        },
        toggleDraftMskuItem(group) {
            const key = this.draftGroupKey(group)
            const position = this.draftMskuExpandedItems.indexOf(key)
            const expand = position === -1
            if (expand) this.draftMskuExpandedItems.push(key)
            else this.draftMskuExpandedItems.splice(position, 1)
            this.setDraftGroupMskuRowsExpanded(group, expand)
        },
        expandDraftMskuItems() {
            this.draftOriginalConfigExpanded = []
            this.draftMskuExpandedItems = this.newAsinDraftItems.map(group => this.draftGroupKey(group))
            this.draftMskuRowKeys = this.newAsinDraftItems
                .reduce((keys, group) => keys.concat(this.draftAllocationRowKeys(group)), [])
        },
        collapseDraftMskuItems() {
            this.draftMskuExpandedItems = []
            this.draftMskuRowKeys = []
        },
        draftAllocationRowKeys(group) {
            return this.draftAllocationRows(group)
                .map(row => String(row.detail_id || '')).filter(Boolean)
        },
        setDraftGroupMskuRowsExpanded(group, expand) {
            const keys = this.draftAllocationRowKeys(group)
            if (!keys.length) return
            if (!expand) {
                this.draftMskuRowKeys = this.draftMskuRowKeys.filter(key => keys.indexOf(key) === -1)
                return
            }
            this.draftMskuRowKeys = Array.from(new Set(this.draftMskuRowKeys.concat(keys)))
        },
        onDraftMskuRowExpand(row, expanded) {
            // 展开状态统一由 draftMskuRowKeys 维护，避免表格数据刷新后字段详情被折叠。
            const key = String((row && row.detail_id) || '')
            if (!key) return
            const isExpanded = Array.isArray(expanded)
                ? expanded.some(item => String((item && item.detail_id) || '') === key)
                : !!expanded
            const keys = this.draftMskuRowKeys.filter(item => item !== key)
            if (isExpanded) keys.push(key)
            this.draftMskuRowKeys = keys
        },
        isDraftOriginalConfigExpanded(group) {
            return this.draftOriginalConfigExpanded.includes(this.draftGroupKey(group))
        },
        toggleDraftOriginalConfig(group) {
            const key = this.draftGroupKey(group)
            const position = this.draftOriginalConfigExpanded.indexOf(key)
            if (position === -1) this.draftOriginalConfigExpanded.push(key)
            else this.draftOriginalConfigExpanded.splice(position, 1)
        },
		draftGroupKey(group) {
			return `${group.parent || ''}|${group.pm || ''}|${group.shop || ''}`
		},
		draftAllocationRows(group) {
			return (group && group.allocation_rows) || []
		},
		draftAllocatedTotal(group) {
			return this.draftAllocationRows(group).reduce((sum, row) => sum + Number(row.quantity || 0), 0)
		},
		draftGroupBase(group) {
			const config = (group && group.draft_config) || {}
			return String(config.base || (group && (group.base || group.base_name)) || '').trim()
		},
		draftProductTypeLabel(productType) {
			const value = String(productType || '').trim()
			if (!value) return ''
			const found = (this.procurementProductTypes || []).find(item => item.value === value)
			return found ? (found.label + '（' + value + '）') : value
		},
		// 与 Auto 的 batchAsinFieldValueText 同一口径：空值统一显示“未填写”，
		// 尺寸/重量等对象按可读文本展示，而不是 JSON。
		draftFieldDisplayText(row, descriptor) {
			const values = (row && row.field_values) || {}
			const field = (descriptor && descriptor.field) || {}
			let value = Object.prototype.hasOwnProperty.call(descriptor || {}, 'configValue')
				? descriptor.configValue : values[descriptor.key]
			if (value === undefined || value === null || value === '') value = descriptor.value
			if ((value === undefined || value === null || value === '')
				&& field.default_value !== undefined && field.default_value !== null
				&& field.default_value !== '') {
				value = field.default_value
			}
			if (value === undefined || value === null || value === '') {
				return ['item_name', 'title_differentiation'].includes(descriptor.key) ? '' : '未填写'
			}
			if (value === true) return '是'
			if (value === false) return '否'
			if (field.field_name === 'item_package_dimensions' && typeof value === 'object') {
				const parts = ['length', 'width', 'height'].map(key => value[key] === undefined ? '-' : value[key])
				return parts.join(' × ') + (value.unit ? ' ' + value.unit : '')
			}
			if (field.field_name === 'item_package_weight' && typeof value === 'object') {
				return (value.value === undefined ? '-' : value.value) + (value.unit ? ' ' + value.unit : '')
			}
			if (Array.isArray(value)) {
				return value.map(item => (item && typeof item === 'object'
					? (item.label || item.value || item.name || JSON.stringify(item)) : String(item))).join('、')
			}
			if (typeof value === 'object') return Object.values(value).join(' / ')
			return String(value)
		},
		// 品名原配置：标题/副标题 + 该产品类型的全部创建字段（默认值来自品名/父体配置）。
		draftConfigPreviewFields(group) {
			if (!group || !group.product_type) return []
			const titles = group.titles || {}
			const hasMainTitle = Object.prototype.hasOwnProperty.call(group, 'title_main_base')
			const hasSubTitle = Object.prototype.hasOwnProperty.call(group, 'title_sub_base')
			const fields = [
				{ key: 'item_name', label: '标题',
					configValue: hasMainTitle ? group.title_main_base : titles.item_name },
				{ key: 'title_differentiation', label: '副标题',
					configValue: hasSubTitle ? group.title_sub_base : titles.title_differentiation },
			]
			const seen = new Set(fields.map(item => item.key))
			;(group.fields || []).forEach(field => {
				if (!field || !field.field_name || seen.has(field.field_name)) return
				seen.add(field.field_name)
				fields.push({ key: field.field_name, label: field.title_zh || field.field_name, field })
			})
			return fields
		},
		// 单个 MSKU 的全部字段：主标题/副标题 + 该产品类型字段，值与 Auto 同样格式化。
		draftMskuFieldRows(group, row) {
			const descriptors = [
				{ key: 'item_name', label: '主标题', field: { field_name: 'item_name' } },
				{ key: 'title_differentiation', label: '副标题', field: { field_name: 'title_differentiation' } },
			]
			const seen = new Set(descriptors.map(field => field.key))
			;((group && group.fields) || []).forEach(field => {
				if (!field || !field.field_name || seen.has(field.field_name)) return
				seen.add(field.field_name)
				descriptors.push({
					key: field.field_name,
					label: field.title_zh || field.field_name,
					field,
					required: !!field.required,
				})
			})
			return descriptors.map(descriptor => ({
				...descriptor,
				value: this.draftFieldDisplayText(row, descriptor),
			}))
		},
		draftValueText(value) {
			if (value === null || value === undefined) return ''
			if (typeof value === 'object') return JSON.stringify(value)
			return String(value)
		},
		draftFieldText(row, fieldName) {
			const values = row && row.field_values || {}
			return this.draftValueText(values[fieldName])
		},
		setDraftFieldText(row, fieldName, value) {
			if (!row.field_values) this.$set(row, 'field_values', {})
			let next = value
			if (typeof value === 'string' && (value.trim().startsWith('{') || value.trim().startsWith('['))) {
				try { next = JSON.parse(value) } catch (error) { next = value }
			}
			this.$set(row.field_values, fieldName, next)
		},
		syncDraftPlan() {
			if (!this.newAsinDraft || !this.newAsinDraft.plan) return
			this.newAsinDraftItems.forEach(group => {
				const quantities = {}
				const values = {}
				;(group.allocation_rows || []).forEach(row => {
					quantities[row.msku || row.detail_id] = Number(row.quantity || 0)
					values[row.msku || row.detail_id] = row.field_values || {}
				})
				this.$set(group, 'msku_quantities', quantities)
				this.$set(group, 'msku_field_values', values)
				this.$set(group, 'allocated_total', Object.keys(quantities).reduce((sum, key) => sum + quantities[key], 0))
			})
		},
		openNewAsinDraft(draftOrId, showDialog = true) {
            if (!this.procurementProductTypes.length) {
                this.$axios.get('/vue/vue_product/product-types').then(res => {
                    if (res.code === 200) this.procurementProductTypes = res.data || []
                }).catch(() => {})
            }
			const draftId = typeof draftOrId === 'string' ? draftOrId : draftOrId && draftOrId.draft_id
			if (!draftId) return this.$message.warning('缺少新建 ASIN 草稿标识')
			this.persistProcurementContext(this.procurementRequestId, draftId)
			return this.$axios.get('/vue/parent_calculate/procurement-draft', { params: { draft_id: draftId } })
				.then(res => {
					if (res.msg !== 'success' || !res.data) throw new Error(res.message || '草稿查询失败')
					this.newAsinDraft = res.data
					this.draftGenerationOperationId = ''
					this.syncDraftGenerationRows()
					this.draftSavedGenerationSignature = this.draftGenerationSignature()
					this.refreshDraftLengthBudgets()
                    this.expandDraftMskuItems()
                    this.draftView = this.newAsinDraft.status === 'confirmed' ? 'result' : (this.draftHasGenerated ? 'preview' : 'config')
					if (showDialog) this.newAsinDraftVisible = true
				}).catch(error => this.$message.error(error.message || '草稿查询失败'))
		},
		saveNewAsinDraft(silent = false, refreshConfig = false, regenerate = false) {
			if (!this.newAsinDraft || this.newAsinDraft.status !== 'draft') return Promise.resolve(this.newAsinDraft)
			this.syncDraftGenerationRows()
			this.syncDraftPlan()
			this.newAsinDraftSaving = true
			const manualByKey = {}
			this.newAsinDraftItems.forEach(group => {
				manualByKey[this.draftGroupKey(group)] = { ...(group._draftManualFields || {}) }
			})
			const payload = {
				draft_id: this.newAsinDraft.draft_id,
				version: this.newAsinDraft.version,
                refresh_config: refreshConfig,
				regenerate: !!regenerate,
				items: this.newAsinDraftItems.map(group => ({
					...group, allocation_rows: (group.allocation_rows || []).map(row => ({
						...row, field_values: row.field_values || {},
					})),
				})),
			}
			if (regenerate && this.draftGenerationOperationId) {
				payload.generation_operation_id = this.draftGenerationOperationId
			}
			return this.$axios.post('/vue/parent_calculate/procurement-draft/update', payload)
				.then(res => {
					if (res.msg !== 'success' || !res.data) throw new Error(res.message || '草稿保存失败')
					this.newAsinDraft = res.data.draft
					this.newAsinDraftItems.forEach(group => {
						this.$set(group, '_draftManualFields', manualByKey[this.draftGroupKey(group)] || {})
					})
					this.syncDraftGenerationRows()
					this.draftSavedGenerationSignature = this.draftGenerationSignature()
					if (regenerate) this.draftGenerationOperationId = ''
					if (this.draftView === 'preview' && !this.draftHasGenerated) this.draftView = 'config'
					if (!silent) this.$message.success('草稿已保存，版本已更新')
					return this.newAsinDraft
				}).catch(error => {
					if (!silent) this.$message.error(error.message || '草稿保存失败')
					throw error
				}).finally(() => { this.newAsinDraftSaving = false })
		},
		exportNewAsinDraft() {
			if (!this.newAsinDraft) return
			return this.saveNewAsinDraft(true).then(draft => this.$axios.post('/vue/parent_calculate/procurement-draft/export', {
				draft_id: draft.draft_id,
			}, { responseType: 'blob' })).then(res => {
				this.downloadBlob(res, `新建ASIN采购草稿_${this.newAsinDraft.draft_id}.xlsx`)
			}).catch(() => this.$message.error('新建 ASIN 草稿导出失败'))
		},
		pickProcurementDraftImport() {
			if (!this.newAsinDraft || this.newAsinDraft.status !== 'draft') return
			if (this.$refs.procurementDraftFile) this.$refs.procurementDraftFile.click()
		},
		onProcurementDraftFilePicked(event) {
			const file = event && event.target && event.target.files && event.target.files[0]
			if (!file || !this.newAsinDraft) return
			const form = new FormData()
			form.append('draft_id', this.newAsinDraft.draft_id)
			form.append('file', file)
			this.newAsinDraftImporting = true
			const request = this.$axios.post('/vue/parent_calculate/procurement-draft/import', form, {
				headers: { 'Content-Type': 'multipart/form-data' },
			}).then(res => {
				if (res.msg !== 'success' || !res.data) throw new Error(res.message || '草稿导入失败')
				this.newAsinDraft = res.data.draft
				this.syncDraftGenerationRows()
				this.draftSavedGenerationSignature = this.draftGenerationSignature()
				this.refreshDraftLengthBudgets()
				this.draftView = this.draftHasGenerated ? 'preview' : 'config'
				this.$message.success('逐 MSKU 草稿已覆盖并重新校验')
			}).catch(error => this.$message.error(error.message || '草稿导入失败'))
				.finally(() => { this.newAsinDraftImporting = false })
			if (event.target) event.target.value = ''
            return request
		},
		confirmNewAsinDraft() {
			if (!this.newAsinDraft || this.newAsinDraft.status !== 'draft') return
			if (!this.draftHasGenerated) {
				this.draftView = 'config'
				return this.$message.warning('请先重新生成有效的 MSKU 预览，再确认新建 ASIN 采购')
			}
			this.newAsinDraftConfirming = true
			const key = `parent_calculate_confirm_${this.newAsinDraft.draft_id}`
			let confirmRequestId = ''
			try { confirmRequestId = window.localStorage.getItem(key) || '' } catch (error) { /* ignore */ }
			if (!confirmRequestId) {
				confirmRequestId = this.newProcurementRequestId('pcconfirm')
				try { window.localStorage.setItem(key, confirmRequestId) } catch (error) { /* ignore */ }
			}
			this.saveNewAsinDraft(true).then(draft => {
                if ((draft.validation_errors || []).length) throw new Error('请先补齐预览中的缺失配置，再确认提交')
                return this.$axios.post(
				'/vue/parent_calculate/procurement-draft/confirm', {
					draft_id: draft.draft_id, version: draft.version,
					confirm_request_id: confirmRequestId,
				})}).then(res => {
				if (res.msg !== 'success' || !res.data) throw new Error(res.message || '新建 ASIN 正式确认失败')
				this.newAsinDraft = { ...this.newAsinDraft, status: 'confirmed' }
                this.draftView = 'result'
				this.procurementResult = {
					request_id: res.data.request_id || confirmRequestId,
					status: 'confirmed', normal: { status: 'not_selected', items: [], message: '' },
					new_asin_draft: this.newAsinDraft,
					message: res.data.message || '新建 ASIN 采购任务已进入统一监控',
				}
				this.persistProcurementContext(this.procurementRequestId, this.newAsinDraft.draft_id)
				if (this.projectf && this.filterText) this.jojo1(this.projectf)
				this.$message.success('已确认，任务将完成刊登、同步和配对，整批准备结束后采购就绪项')
			}).catch(error => this.$message.error(error.message || '新建 ASIN 正式确认失败'))
				.finally(() => { this.newAsinDraftConfirming = false })
		},

		// === 页面加载 & 搜索 ===
		loadParentList() {
			this.$axios.get('/vue/auto_update/seller_asin_select', { params: {} }).then(res => {
				if (res.msg === 'success') {
					this.allParentList = res.data || [];
				}
			}).catch(() => { });
		},
		onShopChange() {
			this.filterText = this.searchForm.shop;
			// 店铺决定站点与锁定仓库，切换后需重新带出。
			this.loadProcurementContext(this.searchForm.shop);
            this.onParentChange();
		},
        onParentChange() {
            this.tableData1 = []; this.projectf = '';
            if (this.searchForm.shop && this.searchForm.parentName) this.handleSearch();
        },
		handleSearch() {
			const shop = this.searchForm.shop;
			const pname = this.searchForm.parentName;
			if (!shop) return this.$message.warning('请先选择店铺');
			if (!pname) return this.$message.warning('请先选择本地父体');
			this.filterText = shop;
			this.jojo(pname);
		},
		resetSearch() {
			this.searchForm = { shop: '', parentName: '' };
			this.filterText = '';
			this.tableData1 = [];
			this.projectf = '';
		},

		clearSelect(changed) {
			// 1. 清空已选择的值

			if (changed) {
				this.sku = []
				this.select_sku(this.title)
			}
			else {
				this.sku = [];
			}



		},

		sortBy30Days(a, b) {
			// a和b是表格中的两行数据
			// 升序：a - b；降序：b - a（方法内部会根据点击自动切换）
			return a.三十天销量 - b.三十天销量;
		},






		getRowStyle(row) {
			if (this.calculateSafetyStock(row.row) < 70) {
				return { backgroundColor: '#FFF9C4' };
			}
			return {};
		},
		calculateSafetyStock(row) {
			if (!row['三十天销量'] || row['三十天销量'] === 0) return 0;
			const safetyStock = (row['FBA库存'] + row['FBA在途']) / row['三十天销量'] * 30;
			return Math.round(safetyStock);
		},
		productStatusType(status) {
			const m = {
				'正常': 'success', '后补': 'danger',
				'待淘汰-正常移入': 'warning', '淘汰移出': 'warning',
			};
			return m[status] || 'info';
		},
		handleSelect_1(row, command) {
			console.log('选中行内容:', row);
			console.log('选中选项:', command);
			if (command == '编辑/详情') {
				this.update(row)
			} else if (command == '指定采购数量') {
				this.zhiding(row)
			} else {
				this.test = []
				this.test = row
				this.update_state_1(row, command)
			}
		},
		fnskuFeeRatio(item) {
			const raw = item && item.fee_ratio !== undefined ? item.fee_ratio : item && item.value
			if (raw === null || raw === undefined || raw === '') return null
			const ratio = Number(raw)
			return Number.isFinite(ratio) ? ratio : null
		},
		fnskuOptionKey(item) {
			const row = item || {}
			return `${row.fnsku || ''}|${row.msku || ''}|${row.asin || ''}`
		},
		fnskuRateText(item) {
			const ratio = this.fnskuFeeRatio(item)
			return ratio === null || ratio > 1 ? '无数据' : ratio.toFixed(2)
		},
		getRateStyle(value) {
			value = Number(value)
			if (value === null || value === undefined || value === 0) {
				return {};
			}

			if (value > 0.4) {
				return { color: '#f56c6c' }; // 红色
			} else if (value > 0.1 && value <= 0.4) {
				return { color: '#67c23a' }; // 绿色
			}

			return {}; // 默认颜色
		},
		update_state_1(row, state) {
			this.test.状态 = state
			this.$axios.post('/vue/parent_calculate/update_state_1', { row: row, state: state }).then(res => {
				console.log(res);
				if (res.code == 200) {
					let _this = this
					this.$notify.success({
						title: '更改成功',
						message: res.msg,
						duration: 2000,
						onClose: function () { _this.handleClose2() }
					});
				} else {
					this.$notify.error({
						title: '错误',
						message: res.msg,
						duration: 20000
					});
				}
			}).catch(error => {
				console.log(error)
			})
		},
		doubleClickCell(row) {
			this.$set(row, "edit", true)
		},
		levelChange(row) {
			this.$set(row, "edit", false)
			this.$axios.post('/vue/parent_calculate/zhiding_update', row).then(res => {
				if (res.code == 200) {
					let _this = this
					this.$notify.success({
						title: '更改成功',
						message: res.msg,
						duration: 2000,
						onClose: function () { _this.handleClose_zd() }
					});
				} else {
					this.$notify.error({
						title: '错误',
						message: res.msg,
						duration: 2000
					});
				}
			})
				.catch(error => {
					console.log(error)
				})
		},
		open(male_parent) {
			this.$confirm('此操作将收藏该本地父体, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$message({
					type: 'success',
					message: '收藏成功!'
				})
				this.$axios.post('/vue/parent_calculate/menu_collect', { male_parent: male_parent }).then(res => {
					console.log(res)
					this.init()
				}).catch(error => {
					console.log(error)
					alert('发生错误:==' + error)
				})
			}).catch(() => {
				// 用户点击取消时的处理（防止报 Uncaught）
				this.$message({
					type: 'info',
					message: '已取消操作'
				})
			})
		},
		open1(male_parent) {
			this.$confirm('此操作将取消收藏该本地父体, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$message({
					type: 'success',
					message: '取消收藏成功!'
				})
				this.$axios.post('/vue/parent_calculate/menu_unbind', { male_parent: male_parent }).then(res => {
					console.log(res)
					this.init()
				}).catch(error => {
					console.log(error)
					alert('发生错误:==' + error)
				})
			}).catch(() => {
				// 用户点击取消时的处理（防止报 Uncaught）
				this.$message({
					type: 'info',
					message: '已取消操作'
				})
			})
		},
		isInSeason(type) {
			const today = new Date();
			const year = today.getFullYear();
			let startDate, endDate;
			if (type === '旺季') {
				startDate = new Date(`${year}-07-30`)
				endDate = new Date(`${year}-11-30`)
			} else if (type === '黑五') {
				startDate = new Date(`${year}-07-30`)
				endDate = new Date(`${year}-11-30`)
			} else if (type === '会员日') {
				const startDate1 = new Date(`${year}-04-15`)
				const endDate1 = new Date(`${year}-07-15`)
				const startDate2 = new Date(`${year}-07-30`)
				const endDate2 = new Date(`${year}-10-15`)
				return (today >= startDate1 && today <= endDate1) || (today >= startDate2 && today <= endDate2);
			}
			return today >= startDate && today <= endDate;
		},
		// 批量计算备货建议并存储到行数据中（用于排序）
		calculateAllSuggestions() {
			if (this.tableData1 && this.tableData1.length > 0) {
				this.tableData1.forEach(row => {
					row.备货建议 = this.calculateSuggestion(row);
				});
			}
		},

		calculateSuggestion(row) {
			console.log('计算备货建议的行数据:', row);
			let baseDays = row.备货天数;  // 默认使用备货天数
			// 将建议方案中的全角括号统一转为半角，避免批量编辑/单行编辑保存的括号不一致导致匹配失败
			const plan = String(row.建议方案 || '').replace(/（/g, '(').replace(/）/g, ')');
			// 根据不同的建议方案计算备货建议
			let suggestion;
			if (plan === '30天销量/30*备货天数+旺季备货+黑五备货+会员日备货-FBA库存-FBA在途-预计库存') {
				suggestion = Math.round(
					Number(row.三十天销量) / 30 * baseDays
					+ (this.isInSeason('旺季') ? Number(row.旺季备货) : 0)
					+ (this.isInSeason('黑五') ? Number(row.黑五备货) : 0)
					+ (this.isInSeason('会员日') ? Number(row.会员日备货) : 0)
					- Number(row.FBA库存)
					- Number(row.FBA在途)
					- Number(row.预计库存)
				);
				// 如果备货建议为正数，将备货天数设为 120，并重新计算
				if (suggestion > 0) {
					baseDays = 120;
					suggestion = Math.round(
						Number(row.三十天销量) / 30 * baseDays
						+ (this.isInSeason('旺季') ? Number(row.旺季备货) : 0)
						+ (this.isInSeason('黑五') ? Number(row.黑五备货) : 0)
						+ (this.isInSeason('会员日') ? Number(row.会员日备货) : 0)
						- Number(row.FBA库存)
						- Number(row.FBA在途)
						- Number(row.预计库存)
					);
				}
				return suggestion;
			} else if (plan === '30天销量/30*(备货天数+旺季备货天数+黑五备货天数+会员日备货天数)-FBA库存-FBA在途-预计库存') {
				suggestion = Math.round(
					Number(row.三十天销量) / 30 *
					(baseDays +
						(this.isInSeason('旺季') ? Number(row.旺季备货天数) : 0) +
						(this.isInSeason('黑五') ? Number(row.黑五备货天数) : 0) +
						(this.isInSeason('会员日') ? Number(row.会员日备货天数) : 0))
					- Number(row.FBA库存)
					- Number(row.FBA在途)
					- Number(row.预计库存)
				);
				// 如果备货建议为正数，将备货天数设为 120，并重新计算
				if (suggestion > 0) {
					baseDays = 120;
					suggestion = Math.round(
						Number(row.三十天销量) / 30 *
						(baseDays +
							(this.isInSeason('旺季') ? Number(row.旺季备货天数) : 0) +
							(this.isInSeason('黑五') ? Number(row.黑五备货天数) : 0) +
							(this.isInSeason('会员日') ? Number(row.会员日备货天数) : 0))
						- Number(row.FBA库存)
						- Number(row.FBA在途)
						- Number(row.预计库存)
					);
				}
				return suggestion;
			}
			// 如果没有匹配的建议方案，检查是否所有值都为0
			if (Number(row.会员日备货) === 0 && Number(row.黑五备货) === 0 &&
				Number(row.旺季备货) === 0 && Number(row.备货天数) === 0) {
				return 0;
			}
			return suggestion || 0;
		},
		init() {
			this.loadParentList();
		},

		check_care_parent() {
			this.loadParentList();
		},



		select_sku(pm) {
			this.sku = []
			this.$axios.post('/vue/parent_calculate/select_sku', { pm: pm }).then(res => {
				if (res.msg == 'success') {
					this.sku = res.data || []
				} else {
					console.log(res.data)
				}
			}).catch(error => {
				console.log(error)
				alert('发生错误:==' + error)
			})
		},
		handleSelect(key, keyPath) {
			console.log(key, keyPath);
		},
		update(row) {
			this.title = row.本地品名
			this.form = { ...row }
			this.fnsku = []
			this.fnskuIgnored = []
			this.dialogVisible1 = true
			// 打开明细即按店铺带出锁定仓库（只读）。
			this.loadProcurementContext(this.form['店铺'] || this.filterText)
			this.select_sku(this.form.本地品名)
			if ((this.form.sku || this.form.SKU)
				&& this.form.是否使用新ASIN !== '工具自动生成新ASIN') this.select_fnsku(this.form)
		},
		zhiding(row) {
			this.title = row.本地品名
			this.form = {}
			this.fnsku = {}
			this.sku = {}
			this.form = row
			this.dialogVisible_zd = true
		},
		select_fnsku(row) {
			// 只按店铺 + SKU 查 listing 拿已配对 FNSKU：品名不参与判断；
			// 父体/品名/店铺用于读取该业务行的 ignore_fnsku 忽略清单。
			// 切换店铺或 SKU 时先清空旧选择，并用请求序号防止旧响应覆盖新选择。
			const parent = row && row['本地父体']
			const pm = row && row['本地品名']
			const shop = row && (row['店铺'] || this.filterText)
			const sku = row && (row.sku || row.SKU)
			this.fnsku = []
			this.fnskuIgnored = []
			if (!shop || !sku) return
			const token = ++this.fnskuReqToken
			this.fnskuLoading = true
			this.$axios.post('/vue/parent_calculate/select_fnsku', {
				parent, pm, shop, sku,
			}).then(res => {
				if (token !== this.fnskuReqToken) return  // 旧请求结果不得覆盖新选择
				if (res.msg !== 'success') throw new Error(res.data || '未获取到关联 FNSKU')
				const data = res.data || {}
				this.fnsku = Array.isArray(data) ? data : (data.items || [])
				this.fnskuIgnored = Array.isArray(data) ? [] : (data.ignored || [])
				if (!this.fnsku.length && !this.fnskuIgnored.length) {
					this.$message.info('当前 SKU 在该店铺暂无已配对的 FNSKU')
				}
			}).catch(error => {
				if (token !== this.fnskuReqToken) return
				console.log(error)
				this.$message.error('FNSKU 关联查询失败：' + ((error && error.message) || '请稍后重试'))
			}).finally(() => {
				if (token === this.fnskuReqToken) this.fnskuLoading = false
			})
		},
		ignoreFnsku(item) {
			// 记入该业务行的 ignore_fnsku：从可选列表移入“已忽略”，可随时恢复。
			const fnsku = item && item.fnsku
			const row = this.form || {}
			const parent = row['本地父体'] || ''
			const pm = row['本地品名'] || ''
			const shop = row['店铺'] || this.filterText || ''
			const sku = row.sku || row.SKU || ''
			if (!fnsku || !parent || !pm || !shop) return
			this.$confirm(`不再在「${pm}」的 FNSKU 下拉中优先显示 ${fnsku}？`, '提示', {
				type: 'warning', confirmButtonText: '忽略', cancelButtonText: '取消',
			}).then(() => this.$axios.post('/vue/parent_calculate/ignore_fnsku', {
				parent, pm, shop, sku, fnsku, action: 'add',
			})).then(res => {
				if (!res || res.msg !== 'success') throw new Error((res && res.msg) || '忽略失败')
				this.fnsku = this.fnsku.filter(option => this.fnskuOptionKey(option) !== this.fnskuOptionKey(item))
				this.fnskuIgnored = this.fnskuIgnored.concat([{ ...item, ignored: true }])
				this.$message.success('已忽略，该项排在下拉最后，点恢复按钮可还原')
			}).catch(error => {
				if (error === 'cancel' || error === 'close') return
				this.$message.error('忽略失败：' + ((error && error.message) || '请稍后重试'))
			})
		},
		restoreFnsku(item) {
			// 复用同一接口的 action=remove，把 FNSKU 恢复为可选。
			const fnsku = item && item.fnsku
			const row = this.form || {}
			const parent = row['本地父体'] || ''
			const pm = row['本地品名'] || ''
			const shop = row['店铺'] || this.filterText || ''
			const sku = row.sku || row.SKU || ''
			if (!fnsku || !parent || !pm || !shop) return
			this.$axios.post('/vue/parent_calculate/ignore_fnsku', {
				parent, pm, shop, sku, fnsku, action: 'remove',
			}).then(res => {
				if (!res || res.msg !== 'success') throw new Error((res && res.msg) || '恢复失败')
				this.fnskuIgnored = this.fnskuIgnored.filter(
					option => this.fnskuOptionKey(option) !== this.fnskuOptionKey(item))
				this.fnsku = this.fnsku.concat([{ ...item, ignored: false }])
				this.$message.success('已恢复该 FNSKU')
			}).catch(error => {
				this.$message.error('恢复失败：' + ((error && error.message) || '请稍后重试'))
			})
		},
		// 店铺 → 站点 → 锁定仓库：选择店铺后自动带出，明细只读。
		loadProcurementContext(shop, target) {
			if (!shop) {
				if (target === 'requirement') this.newAsinRequirementContext = {}
				else this.procurementContext = {}
				return
			}
			this.$axios.get('/vue/vue_product/procurement-context', { params: { shop } })
				.then(res => {
					if (res.code !== 200 || !res.data) return
					if (target === 'requirement') {
						this.newAsinRequirementContext = res.data
						if (res.data.warehouse) this.$set(this.newAsinRequirementForm, 'warehouse', res.data.warehouse)
					} else {
						this.procurementContext = res.data
						if (res.data.warehouse) this.$set(this.form, '仓库', res.data.warehouse)
					}
				}).catch(() => { })
		},
		onEditSkuChange(sku) {
			// 切换 SKU 时清空旧 FNSKU 与旧仓库选择，避免残留上一个 SKU 的选择。
			this.$set(this.form, 'fnsku', '')
			this.$set(this.form, '仓库', this.lockedWarehouse || '')
			this.fnsku = []
			this.fnskuIgnored = []
			if (sku && this.form.是否使用新ASIN !== '工具自动生成新ASIN') this.select_fnsku(this.form)
		},
		onEditAsinModeChange(mode) {
			this.fnsku = []
			this.fnskuIgnored = []
			if (mode !== '工具自动生成新ASIN' && (this.form.sku || this.form.SKU)) {
				this.select_fnsku(this.form)
			}
		},
		/* 暂时关闭新建 ASIN 采购的源 FNSKU 和后缀配置流程。
		sourceFnskuLabel(item) {
			const fee = item && item.fee_ratio !== null && item.fee_ratio !== undefined
				? Number(item.fee_ratio).toFixed(2) : '无数据'
			return (item.fnsku || '') + '（佣金 ' + fee + '，ASIN ' + (item.asin || '-') + '）'
		},
		openSourceFnskuDialog(row, continueHandler) {
			this.sourceFnskuRow = row
			this.sourceFnskuValue = row.source_fnsku || ''
			this.sourceMskuSuffix = row.msku_suffix || 'T'
			this.sourceMskuCustomSuffix = row.msku_custom_suffix || ''
			this.sourceFnskuOptions = []
			this.sourceFnskuContinue = continueHandler
			this.sourceFnskuDialogVisible = true
			const actualShop = (row['店铺'] || this.filterText) === 'EU' ? 'CoBak-DE' : (row['店铺'] || this.filterText)
			this.sourceFnskuLoading = true
			this.$axios.post('/vue/parent_calculate/select_fnsku', {
				pm: row['本地品名'], shop: actualShop
			}).then(res => {
				if (res.msg === 'success') {
					this.sourceFnskuOptions = (res.data || []).filter(item => {
						const fee = Number(item.fee_ratio !== undefined ? item.fee_ratio : item.value)
						return Number.isFinite(fee) && fee > 0.4
					})
				}
			}).catch(() => {
				this.sourceFnskuOptions = []
			}).finally(() => {
				this.sourceFnskuLoading = false
			})
		},
		cancelSourceFnsku() {
			this.sourceFnskuDialogVisible = false
			this.sourceFnskuContinue = null
		},
		confirmSourceFnskuSelection() {
			const row = this.sourceFnskuRow
			if (!row) return this.cancelSourceFnsku()
			if (this.sourceMskuSuffix === 'CUSTOM'
				&& !/^[A-Za-z0-9]{1,6}$/.test((this.sourceMskuCustomSuffix || '').trim())) {
				this.$message.warning('MSKU 后缀需为 1-6 位英文字母或数字')
				return
			}
			this.$set(row, 'source_fnsku', this.sourceFnskuValue || '')
			const selected = this.sourceFnskuOptions.find(item => item.fnsku === this.sourceFnskuValue)
			this.$set(row, 'source_asin', selected ? (selected.asin || '') : '')
			this.$set(row, 'source_fee_ratio', selected ? (selected.fee_ratio !== undefined ? selected.fee_ratio : selected.value) : null)
			this.$set(row, 'msku_suffix', this.sourceMskuSuffix === 'CUSTOM'
				? this.sourceMskuCustomSuffix : this.sourceMskuSuffix)
			this.$set(row, 'msku_custom_suffix', this.sourceMskuCustomSuffix)
			const handler = this.sourceFnskuContinue
			this.cancelSourceFnsku()
			if (handler) handler()
		},
		*/
        auto_caigou(requestId, shop = this.filterText, parent = this.searchForm.parentName) {
            this.isSending18 = true
            this.procurementRequestId = requestId
			return this.$axios.post('/vue/parent_calculate/auto_caigou', {
				shop, parent,
				request_id: requestId,
				_procurement_request_id: requestId,
			}, { headers: { 'Idempotency-Key': requestId } }).then(res => {
				if (res.msg == 'success') {
					this.procurementResult = res.data || {}
                    if (shop === this.filterText && parent === this.searchForm.parentName) this.jojo(parent)
					if (this.procurementResult.new_asin_draft) {
						this.persistProcurementContext(requestId, this.procurementResult.new_asin_draft.draft_id)
					}
                    this.procurementResultVisible = !this.procurementResult.new_asin_draft
                    if (this.procurementResult.new_asin_draft) this.openNewAsinDraft(this.procurementResult.new_asin_draft)
                    // 有草稿时结果弹窗不会打开，被占用的品名必须单独提示，否则会被当成已处理。
                    const occupied = this.procurementResult.occupied_items || []
                    if (occupied.length && this.procurementResult.new_asin_draft) {
                        this.$notify.warning({
                            title: '以下品名已被未确认草稿占用，本次未处理',
                            message: occupied.map(item => item.pm + '（占用者：'
                                + (item.occupied_by_owner || '—') + '，草稿 ' + item.occupied_by + '）').join('；'),
                            duration: 8000,
                        })
                    }
				} else {
					this.$notify.error({
						title: '一键采购请求失败',
						message: this.getProcurementErrorMessage(res.data || res.message),
						duration: 3000,
					})
				}
			}).catch(error => {
				console.log(error)
				this.$notify.error({
					title: '创建采购计划失败',
					message: '请求结果尚未确认，请重试本次请求或从任务面板核查',
					duration: 3000,
				})
				this.$confirm('网络请求失败，是否使用原请求编号重试？', '重试本次请求').then(() => this.auto_caigou(requestId, shop, parent)).catch(() => {})
			}).finally(() => {
				this.isSending18 = false
			})
		},
		getProcurementErrorMessage(message) {
			const detail = String(message || '').trim()
			if (!detail) return '创建计划失败，请重试'
			if (detail.includes('创建计划调用失败')) return '创建计划调用失败，请重试'
			if (detail.includes('ERP') || detail.includes('createPurchasePlan')
				|| detail.includes('接口') || detail.includes('网关') || detail.includes('超时')) {
				return '创建计划调用失败，请重试'
			}
			// 后端校验信息可帮助用户补全配置；其余内部错误不直接暴露给用户。
			if (detail.includes('缺少 FNSKU') || detail.includes('不支持的采购模式')
				|| detail.includes('尚未完成品名配置') || detail.includes('全部品名校验失败')
				|| detail.includes('没有可采购的品名')) {
				return detail
			}
			return '创建计划失败，请重试'
		},
		purchaseRowKey(row) {
			const shop = row['店铺'] === 'EU' ? 'CoBak-DE' : row['店铺']
            return `${row['本地父体']}|${row['本地品名']}|${shop}`
		},
		updatePurchaseState(row, purchaseSwitch, extraFields = {}) {
			const rowKey = this.purchaseRowKey(row)
			const patch = item => {
				if (item === row || this.purchaseRowKey(item) === rowKey) {
					return { ...item, '采购开关': purchaseSwitch, ...extraFields }
				}
				return item
			}
			// 用新数组替换数据源，确保 Element UI 表格立即重新计算 v-if/v-else-if。
			this.tableData1 = (this.tableData1 || []).map(patch)
			this.tableData3 = (this.tableData3 || []).map(patch)
			this.$set(row, '采购开关', purchaseSwitch)
			Object.keys(extraFields).forEach(key => this.$set(row, key, extraFields[key]))
		},
		resetPurchaseStateAfterAutoProcure(rows) {
			const completedKeys = new Set((rows || []).map(row => this.purchaseRowKey(row)))
			const patch = item => {
				if (!completedKeys.has(this.purchaseRowKey(item))) return item
				const resetItem = { ...item, '采购开关': '不启用一键采购' }
				delete resetItem.purchase_mode
				return resetItem
			}
			// 后端一键采购成功后会关闭采购开关；前端同步还原按钮，避免必须刷新页面。
			this.tableData1 = (this.tableData1 || []).map(patch)
			this.tableData3 = (this.tableData3 || []).map(patch)
		},
		handlePreview(file) {
			console.log(file);
		},
		handleClose() {
			this.dialogVisible = false
			this.init()
		},
		handleClose1() {
			this.dialogVisible1 = false
			this.jojo1(this.form.本地父体)
		},
		handleClose2() {
			this.dialogVisible2 = false
			this.jojo1(this.projectf)
		},
		handleClose_zd() {
			this.dialogVisible_zd = false
		},
		reset() {
			let id = undefined
			if ('id' in this.form) {
				id = this.form.id
			}
			this.form = {}
			if (id != undefined) this.form.id = id
		},
		jojo(project) {
			if (this.filterText == '') {
				alert('请选择店铺')
			} else {
                const shop = this.filterText
				return this.$axios.post('/vue/parent_calculate/parent_select_child', { name: project, shop }).then(res => {
                    if (shop !== this.filterText || project !== this.searchForm.parentName) return
					if (res.msg == 'success') {
						this.tableData1 = res.data
						console.log('/parent_select_child返回的数据', this.tableData1)
						this.projectf = project
						this.calculateAllSuggestions(); // 计算备货建议用于排序
					} else {
						alert('未获取到该父体的品名数据')
					}
				}).catch(error => {
					console.log(error)
					alert('发生错误:==' + error)
				})
			}
		},
        jojo1(project) {
            return this.jojo(project)
        },
        async jojo2() {
            if (!this.filterText || !this.searchForm.parentName) return this.$message.warning('请选择店铺和当前父体')
            if (this.isSending18) return
            this.isSending18 = true
            const shop = this.filterText
            const parent = this.searchForm.parentName
            try {
                const res = await this.$axios.get('/vue/parent_calculate/procurement-pending', { params: { shop, parent } })
                if (res.msg !== 'success') throw new Error(res.message || '待采购范围查询失败')
                const summary = res.data.summary
                const occupied = res.data.occupied_items || []
                if (!summary.products) {
                    // 全部被未确认草稿占用时也要说清是谁占用的，否则用户只会看到“没有需求”。
                    if (occupied.length) {
                        this.$notify.warning({
                            title: '当前父体没有可处理需求：品名已被未确认草稿占用',
                            message: occupied.map(item => item.pm + '（占用者：'
                                + (item.occupied_by_owner || '—') + '，草稿 ' + item.occupied_by + '）').join('；'),
                            duration: 8000,
                        })
                        return
                    }
                    return this.$message.info('当前父体没有可处理需求，未确认草稿请从任务面板继续')
                }
                const occupiedHint = occupied.length ? `，另有 ${occupied.length} 个品名被未确认草稿占用` : ''
                await this.$confirm(`当前父体「${parent}」共 ${summary.products} 个已开启品名：普通采购 ${summary.normal} 项，新建 ASIN ${summary.new_asin} 项${occupiedHint}。提交时以数据库最新需求为准。`, '确认一键采购')
                if (shop !== this.filterText || parent !== this.searchForm.parentName) throw new Error('店铺或父体已切换，请重新确认采购范围')
                await this.auto_caigou(this.newProcurementRequestId('pcprocure'), shop, parent)
            } catch (error) {
                if (error && error.message) this.$message.error(error.message)
            } finally {
                this.isSending18 = false
            }
        },
		caigou1(row) {
			this.selectPurchaseMode(row, 'normal')
		},
		caigou2(row) {
			this.isSending5 = true
			this.$axios.post('/vue/parent_calculate/caigou2', row).then(res => {
				if (res.code === 200) {
					this.updatePurchaseState(row, '不启用一键采购')
					this.$notify.success({ title: '成功', message: res.msg, duration: 2000 })
				} else {
					this.$notify.error({ title: '错误', message: res.msg, duration: 2000 })
				}
			}).catch(error => {
				this.$notify.error({ title: '错误', message: '关闭采购失败: ' + error, duration: 3000 })
			}).finally(() => {
				this.isSending5 = false
			})
		},
		selectPurchaseMode(row, mode) {
			// 新建 ASIN 的 SKU 在专用弹窗中选择，不要求先进入普通编辑弹窗。
			if (mode === 'new_asin') {
				return this.openNewAsinRequirement(row)
			}
			if (!row.sku) {
				this.$message.warning('请先选择SKU')
				return
			}
			if (mode === 'normal' && !row.fnsku) {
				this.$message.warning('普通采购请先选择FNSKU')
				return
			}
			if (!row['仓库']) {
				this.$message.warning('请先选择仓库')
				return
			}
			this.startPurchase(row, 'normal')
		},
		startPurchase(row, mode) {
			if (mode === 'normal' && (!row.fnsku || !row['仓库'])) {
				this.$message.warning('普通采购请先选择 FNSKU 和仓库')
				return
			}
			this.isSending5 = true
			this.$axios.post('/vue/parent_calculate/caigou1', { ...row, purchase_mode: mode }).then(res => {
				if (res.code === 200) {
					this.updatePurchaseState(row, '启用一键采购', {
						purchase_mode: mode,
						'是否使用新ASIN': mode === 'new_asin'
							? '工具自动生成新ASIN' : '工具使用目前选择FNSKU',
					})
					this.$notify.success({ title: '成功', message: res.msg, duration: 2000 })
				} else {
					this.$notify.error({ title: '错误', message: res.msg, duration: 2000 })
				}
			}).catch(error => {
				this.$notify.error({ title: '错误', message: '启动采购失败: ' + error, duration: 3000 })
			}).finally(() => {
				this.isSending5 = false
			})
		},
		validateProcurementMethod(row) {
			if (!row.sku) {
				this.$message.warning('请先选择SKU')
				return false
			}
			return true
		},
		/* 暂时关闭编辑下拉框中的品名配置回调。
		openPmConfig(row) {
			this.pmConfigMeta = {
				'本地父体': row['本地父体'] || '',
				'本地品名': row['本地品名'] || '',
				'店铺': row['店铺'] || this.filterText || '',
				msku: row.msku || '',
				warehouse: row['仓库'] || '',
			}
			this.dialogPmConfigVisible = true
		},
		onPmConfigSaved() {
			this.dialogPmConfigVisible = false
			if (this.pendingConfigRow && this.pendingPurchaseMode === 'new_asin') {
				const row = this.pendingConfigRow
				this.$set(row, '仓库', this.pmConfigMeta.warehouse)
				this.pendingConfigRow = null
				this.pendingPurchaseMode = null
				this.openSourceFnskuDialog(row, () => this.startPurchase(row, 'new_asin'))
			}
		},
		*/
		/* 暂时关闭任务面板及其前端轮询逻辑。
		// 轮询任务状态（单个任务）
		_pollTask(taskId, action) {
			const actionName = action === 'create_and_procure' ? '创建并采购' : '创建'
			const check = () => {
				this.$axios.get('/vue/parent_calculate/task_status', { params: { task_id: taskId } }).then(res => {
					if (res.code != 200) return
					const task = res.data
					const st = task.status
					// 同步更新 taskList 中该条任务
					this._upsertTaskToList(task)
					if (st === 'failed') {
						this.$notify.error({ title: '创建失败', message: task.error || '未知错误', duration: 0 })
						return
					}
					if (st === 'complete') {
						const asin = task.new_asin || ''
						const fnsku = task.new_fnsku || ''
						this.$notify.success({
							title: actionName + '完成',
							message: 'ASIN: ' + asin + '\nFNSKU: ' + fnsku,
							duration: 0
						})
						this._refreshData()
						return
					}
					const msg = task.status_msg || task.step || st
					console.log('[' + taskId + '] ' + msg)
					setTimeout(check, 5000)
				}).catch(() => {
					setTimeout(check, 5000)
				})
			}
			setTimeout(check, 3000)
		},
		// 将任务插入或更新到 taskList
		_upsertTaskToList(task) {
			const idx = this.taskList.findIndex(t => t.task_id === task.task_id)
			if (idx >= 0) {
				this.$set(this.taskList, idx, task)
			} else {
				this.taskList.unshift(task)
			}
			this._updateActiveCount()
		},
		// 刷新数据
		_refreshData() {
			if (this.filterText && this.projectf) {
				this.jojo(this.projectf);
			}
		},
		*/
		allupdate() {
			if (this.filterText != '' && this.projectf != '') {
				this.title = '批量编辑'
				this.dialogVisible2 = true
			} else {
				alert('请先选择父体和店铺')
			}
		},
		/* 暂时关闭任务面板及其前端轮询逻辑（allupdate 属于批量编辑主流程，保持可用）。
		// 打开任务面板弹窗
		openTaskPanel() {
			this.dialogTaskPanel = true
			this._fetchTasks()
		},
		// 拉取任务列表（打开任务面板时调用）
		_fetchTasks() {
			this.$axios.get('/vue/parent_calculate/task_list').then(res => {
				if (res.code == 200) {
					this.taskList = (res.data || []).filter(t =>
						t.action !== 'move_in' && t.action !== 'move_out'
					)
					this._updateActiveCount()
				}
			}).catch(() => {})
		},
		// 页面加载时恢复进行中任务的轮询
		_resumePolling() {
			this.$axios.get('/vue/parent_calculate/task_list').then(res => {
				if (res.code == 200) {
					const tasks = (res.data || []).filter(t =>
						t.action !== 'move_in' && t.action !== 'move_out'
					)
					this.taskList = tasks
					this._updateActiveCount()
					const activeStatuses = ['pending', 'publishing', 'phase1_done', 'phase2_done', 'procuring']
					tasks.forEach(task => {
						if (activeStatuses.includes(task.status)) {
							this._pollTask(task.task_id, task.action || 'create_only')
						}
					})
				}
			}).catch(() => {})
		},
		// 统计进行中的任务数（排除 complete/failed）
		_updateActiveCount() {
			const activeStatuses = ['pending', 'publishing', 'phase1_done', 'phase2_done', 'procuring']
			this.activeTaskCount = this.taskList.filter(t => activeStatuses.includes(t.status)).length
		},
		*/
		update_data() {
			if (this.form.MSKU模版.length > 23) {
				alert('MSKU模版字数超过23，请修改后再提交')
			} else if (this.form.采购开关 == '启用一键采购') {
				if (this.form.sku == '') {
					alert('请先选择sku')
				} else if (this.form.是否使用新ASIN == '工具使用目前选择FNSKU') {
					if (this.form.fnsku == '' || this.form.仓库 == '') {
						alert('请检查fnsku/仓库是否已选择')
					} else {
						this.isSending2 = true
						console.log(this.form);
						this.$axios.post('/vue/parent_calculate/update_data', this.form).then(res => {
							if (res.code == 200) {
								let _this = this
								this.$notify.success({
									title: '成功',
									message: res.msg,
									duration: 2000,
									onClose: function () { _this.handleClose1() }
								});
								this.isSending2 = false
							} else {
								this.$notify.error({
									title: '错误',
									message: res.msg,
									duration: 2000
								});
								this.isSending2 = false
							}
						})
							.catch(error => {
								console.log(error)
								alert('发生错误:==' + '请检查内容是否填写完整')
								this.isSending2 = false
							})
					}
				} else if (this.form.是否使用新ASIN == '工具自动生成新ASIN') {
					if (this.form.MSKU模版 == '' || this.form.供应商 == '' || this.form.仓库 == '' || Number(this.form.指定采购数量) <= 0) {
						alert('请检查指定采购数量/MSKU模版/供应商/仓库是否填写完整')
					} else {
						this.isSending2 = true
						console.log(this.form);
						this.$axios.post('/vue/parent_calculate/update_data', this.form).then(res => {
							if (res.code == 200) {
								let _this = this
								this.$notify.success({
									title: '成功',
									message: res.msg,
									duration: 2000,
									onClose: function () { _this.handleClose1() }
								});
								this.isSending2 = false
							} else {
								this.$notify.error({
									title: '错误',
									message: res.msg,
									duration: 2000
								});
								this.isSending2 = false
							}
						})
							.catch(error => {
								console.log(error)
								alert('发生错误:==' + '请检查内容是否填写完整')
								this.isSending2 = false
							})
					}
				}
			} else {
				this.isSending2 = true
				console.log(this.form);
				this.$axios.post('/vue/parent_calculate/update_data', this.form).then(res => {
					if (res.code == 200) {
						let _this = this
						this.$notify.success({
							title: '成功',
							message: res.msg,
							duration: 2000,
							onClose: function () { _this.handleClose1() }
						});
						this.isSending2 = false
					} else {
						this.$notify.error({
							title: '错误',
							message: res.msg,
							duration: 2000
						});
						this.isSending2 = false
					}
				})
					.catch(error => {
						console.log(error)
						alert('发生错误:==' + '请检查内容是否填写完整')
						this.isSending2 = false
					})
			}
		},
		change_all() {
			if (this.projectf == '') {
				alert('请先选择父体')
			} else {
				this.$confirm('是否要将备货建议全部填入指定采购数量', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '置换成功!'
					})
					this.$axios.post(`/vue/parent_calculate/change_all`, this.tableData1).then(res => {
						console.log(res)
						if (res.msg == 'success') {
							this.jojo(this.projectf)
						}
						// this.applySorting(); // 应用排序
					}).catch(error => {
						console.log(error)
					})
				})
			}
		},
		updateall_data() {
			this.isSending2 = true
			console.log(this.form1);
			this.$axios.post('/vue/parent_calculate/update_alldata', { form: this.form1, data: this.tableData1 }).then(res => {
				if (res.code == 200) {
					let _this = this
					this.$notify.success({
						title: '成功',
						message: res.msg,
						duration: 2000,
						onClose: function () { _this.handleClose2() }
					});
					this.isSending2 = false
				} else {
					this.$notify.error({
						title: '错误',
						message: res.msg,
						duration: 2000
					});
					this.isSending2 = false
				}
			})
				.catch(error => {
					console.log(error)
					alert('发生错误:==' + '请检查内容是否填写完整')
					this.isSending2 = false
				})
		},
		zhiding_update() {
			this.isSending2 = true
			this.$axios.post('/vue/parent_calculate/zhiding_update', this.form).then(res => {
				if (res.code == 200) {
					let _this = this
					this.$notify.success({
						title: '更改成功',
						message: res.msg,
						duration: 2000,
						onClose: function () { _this.handleClose_zd() }
					});
					this.isSending2 = false
				} else {
					this.$notify.error({
						title: '错误',
						message: res.msg,
						duration: 2000
					});
					this.isSending2 = false
				}
			})
				.catch(error => {
					console.log(error)
					alert('发生错误:==' + '请检查内容是否填写完整')
					this.isSending2 = false
				})
		},
		select_pm() {
			if (this.filterText == '') {
				alert('请选择店铺')
			} else {
				this.isSending8 = true
				this.$axios.post(`/vue/parent_calculate/select_pm`, { input: this.select_input, input2: this.select_input2, shop: this.filterText }).then(res => {
					// 调试：查看后端返回的完整数据
					console.log('后端返回的完整res:', res)
					console.log('后端返回的res.data:', res.data)
					this.tableData1 = res.data
					console.log('select_pm返回的数据', this.tableData1)
					this.calculateAllSuggestions(); // 计算备货建议用于排序
					this.isSending8 = false
				}).catch(error => {
					alert(error)
					console.log(error)
					this.isSending8 = false
				})
			}
		},
	},
}
</script>

<style>
.main {
	height: 100%;
	width: 100%;
	background: #f8f9fa;
	min-height: 100vh;
}

.operation-bar {
	background: #fff;
	padding: 12px 20px;
	border-radius: 4px;
	margin-bottom: 16px;
	box-shadow: 0 1px 4px rgba(0,0,0,0.1);
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
}

.search-form {
	display: flex;
	align-items: center;
}
.search-form .el-form-item {
	margin-bottom: 0;
	margin-right: 12px;
}

.action-btns-group {
	display: flex;
	align-items: center;
	gap: 4px;
	flex-shrink: 0;
}

.table-area {
	background: #fff;
	padding: 16px 20px;
	border-radius: 4px;
	box-shadow: 0 1px 4px rgba(0,0,0,0.1);
	overflow: hidden;
}

.table-header-bar {
	display: flex;
	align-items: center;
	margin-bottom: 4px;
}
.table-title {
	font-size: 15px;
	font-weight: 600;
	color: #303133;
	margin-right: 20px;
}

.table-tip {
	white-space: nowrap;
	color: #E6A23C;
	font-size: 12px;
	margin-top: 8px;
	padding: 4px 0;
}

.demo-table-expand {
	font-size: 0;
}
.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}
.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 100%;
}
</style>

<style scoped="scoped">
.purchase-wrapper {
	padding: 5px 0;
	text-align: right;
	line-height: 1.5;
}
.purchase-item {
	font-size: 13px;
	display: inline-block;
	width: 100%;
}
.label {
	color: #909399;
	margin-right: 4px;
}
.value {
	color: #303133;
	font-weight: 500;
}
.purchase-item:first-child {
	margin-bottom: 3px;
}

.sales-wrapper {
	padding: 5px 0;
	line-height: 1.5;
}
.sales-item {
	font-size: 13px;
	color: #606266;
}
.sales-item:not(:last-child) {
	border-bottom: 1px dashed #eee;
	margin-bottom: 3px;
	padding-bottom: 3px;
}

.action-btns {
	display: flex;
	align-items: center;
	gap: 4px;
	flex-wrap: nowrap;
}

.config-layout {
	display: flex;
	gap: 20px;
	align-items: flex-start;
}
.config-left {
	width: 340px;
	flex-shrink: 0;
	border-right: 1px solid #ebeef5;
	padding-right: 20px;
}
.config-right {
	flex: 1;
	min-width: 0;
	max-height: 560px;
	overflow-y: auto;
	padding-left: 6px;
}
.config-meta {
	display: flex;
	flex-wrap: wrap;
	gap: 8px 28px;
	font-size: 13px;
	color: #606266;
	background: #f5f7fa;
	border-radius: 4px;
	padding: 10px 14px;
	margin-bottom: 12px;
}
.meta-item {
	display: inline-flex;
	align-items: center;
}
.meta-label {
	color: #909399;
	margin-right: 6px;
}
.config-empty {
	color: #909399;
	font-size: 13px;
	padding: 12px 0;
}

.dims-row {
	display: flex;
	align-items: center;
	gap: 6px;
}
.dims-x {
	color: #909399;
}
.dims-unit {
	margin-left: 2px;
	font-size: 12px;
	color: #909399;
	white-space: nowrap;
}

.field-help {
	margin-left: 8px;
	font-size: 12px;
	color: #909399;
}
.new-asin-requirement {
	color: #606266;
}
.requirement-meta {
	margin: 16px 0;
}
.procurement-config-title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 4px 0 10px;
}
.procurement-config-title .dialog-section-title {
	margin-bottom: 0;
}
.procurement-config-title .field-help {
	margin-left: 12px;
}
.procurement-config-form {
	padding: 14px 16px 2px;
	border: 1px solid #ebeef5;
	border-radius: 4px;
	background: #fafbfd;
}
.procurement-config-form .el-form-item {
	margin-bottom: 14px;
}
.procurement-config-form .el-form-item__label {
	padding-bottom: 4px;
	line-height: 18px;
}
.requirement-note {
	display: block;
	margin: 8px 0 16px;
}
.allocation-preview {
	padding-top: 14px;
	border-top: 1px solid #ebeef5;
}
.allocation-preview-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	margin-bottom: 10px;
}
.allocation-preview-header .procurement-summary {
	margin: 0;
}
.summary-chip {
	display: inline-block;
	padding: 4px 10px;
	border-radius: 12px;
	background: #f0f7ff;
	color: #409eff;
	white-space: nowrap;
}
.procurement-summary {
	display: flex;
	gap: 28px;
	margin: -4px 0 10px;
	color: #606266;
	font-size: 13px;
}
.dialog-section-title {
	font-weight: 600;
	color: #303133;
	margin-bottom: 8px;
}
.draft-entry-card {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 18px;
	padding: 12px 14px;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	background: #f5f7fa;
}
.draft-toolbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	margin: 14px 0;
	color: #606266;
	font-size: 13px;
}
.draft-group {
	margin-bottom: 16px;
	border: 1px solid #ebeef5;
	border-radius: 4px;
	padding: 10px;
}
.draft-group-header {
	display: flex;
	justify-content: space-between;
	gap: 16px;
	margin-bottom: 8px;
	color: #606266;
	font-size: 13px;
}
/* Keep the draft actions visible while browsing product cards. */
::v-deep .procurement-draft-dialog { display: flex; flex-direction: column; max-height: 94vh; margin-bottom: 0; }
::v-deep .procurement-draft-dialog .el-dialog__body { overflow-y: auto; padding: 10px 20px; }
::v-deep .procurement-draft-dialog .el-dialog__footer { border-top: 1px solid #ebeef5; padding: 14px 20px; }
.draft-dialog-title, .draft-footer, .draft-footer-actions { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; }
.draft-config-step, .draft-result-step { min-height: 55vh; }
.draft-config-errors { margin-top: 12px; }
.draft-dialog-title { gap: 24px; padding-right: 24px; }
.draft-dialog-title > span { font-size: 18px; }
.draft-validation { max-height: 150px; overflow-y: auto; }
.draft-group { padding: 14px; }
.draft-group-header { align-items: center; justify-content: flex-start; flex-wrap: wrap; gap: 8px 14px; }
.draft-group-summary, .draft-row-context, .draft-footer-summary { color: #909399; font-size: 12px; line-height: 1.8; }
.draft-generation-config { padding: 8px 0; }
.draft-group-parent { color: #909399; }
.draft-fixed-note { margin-left: 6px; color: #c0c4cc; font-style: normal; }
.draft-row-context { padding: 0 14px 10px; overflow-wrap: anywhere; }
.draft-required { color: #f56c6c; }
/* FNSKU 下拉每项右侧的「忽略」按钮 */
.fnsku-ignore-icon { float: right; margin-top: 10px; color: #c0c4cc; cursor: pointer; }
.fnsku-ignore-icon:hover { color: #f56c6c; }
/* FNSKU 下拉：字段分色（FNSKU 蓝 / MSKU 黑），佣率文本按佣金比例着色 */
.fnsku-part-fnsku { color: #409eff; }
.fnsku-part-msku { color: #303133; }
.fnsku-part-sep { color: #909399; }
.fnsku-part-ignored { color: #c0c4cc; }
/* 已忽略项排在下拉最后：右侧为恢复按钮 */
.fnsku-restore-icon { float: right; margin-top: 10px; color: #409eff; cursor: pointer; }
.fnsku-restore-icon:hover { color: #66b1ff; }
/* 生成 MSKU 的展示样式与 Auto 批量新建ASIN 保持一致 */
.gen-multi-result-summary { margin-bottom: 12px; }
.batch-asin-generated-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 8px; margin: 4px 0 8px; color: #606266; font-size: 12px; }
.batch-asin-generated-toolbar-actions { display: inline-flex; align-items: center; gap: 8px; white-space: nowrap; }
.batch-asin-config-preview { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 6px 14px; max-height: 220px; overflow-y: auto; margin-top: 8px; padding: 8px 10px; background: #f7f9fc; border: 1px solid #e8edf5; border-radius: 4px; }
.batch-asin-config-item { display: flex; align-items: flex-start; min-width: 0; gap: 6px; color: #606266; font-size: 12px; line-height: 1.5; }
.batch-asin-config-label { flex: 0 0 118px; color: #909399; text-align: right; overflow-wrap: anywhere; }
.batch-asin-config-value { min-width: 0; color: #303133; word-break: break-all; }
.batch-asin-config-value.is-empty { color: #f56c6c; }
.batch-asin-config-empty { margin-top: 8px; padding: 8px 10px; color: #e6a23c; font-size: 12px; background: #fdf6ec; border: 1px solid #f5dab1; border-radius: 4px; }
.batch-asin-msku-toggle-row { display: flex; align-items: center; justify-content: space-between; gap: 8px; margin-top: 10px; padding-top: 8px; border-top: 1px solid #ebeef5; color: #606266; font-size: 12px; }
.batch-asin-item-mskus { margin-top: 6px; }
.batch-asin-msku-field-hint { margin-left: 8px; color: #909399; font-style: normal; font-size: 11px; }
.batch-asin-msku-field-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 8px 14px; padding: 10px 14px; background: #fafafa; }
.batch-asin-msku-field-item { min-width: 0; line-height: 1.5; }
.batch-asin-msku-field-label { display: block; color: #909399; font-size: 11px; }
.batch-asin-msku-field-value { display: block; color: #303133; word-break: break-word; white-space: pre-wrap; font-size: 12px; }
.batch-asin-msku-field-value.is-empty { color: #c0c4cc; }
.draft-footer { justify-content: space-between; text-align: left; }
.draft-footer-actions { justify-content: flex-end; }
.draft-footer-actions .el-button { margin-left: 0; }
@media (max-width: 640px) { .draft-toolbar { flex-wrap: wrap; } }
@media (max-width: 640px) {
	.procurement-config-title,
	.allocation-preview-header {
		align-items: flex-start;
		flex-direction: column;
	}
	.procurement-config-title .field-help {
		margin-left: 0;
	}
}
</style>
